webpackJsonp([1],{

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(395);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: {
    uid: {},
    blh: null,
    certificationProcess: null,
    continueWithMinimum: false,
    equipmentList: [],
    areasList: [],
    pending: false,
    step: 0,
    currPhotoArea: 0,
    currPhotoType: 'vertices'
  },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */]
}));

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(733)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(842),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-be88b618",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(832),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49695c0a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_LoginView__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_LoginView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_LoginView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_HomeView__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_HomeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_HomeView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_AreaView__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_AreaView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_AreaView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_StructureView__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_StructureView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_StructureView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_PhotosView__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_PhotosView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_PhotosView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_CameraView__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_CameraView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_CameraView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_SyncView__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_SyncView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_SyncView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_SyncQueue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_SyncQueue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_SyncQueue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_SyncAreaPhotos__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_SyncAreaPhotos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_SyncAreaPhotos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(211);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function requireAuth(to, from, next) {
  __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('CURRENT_USER').then(function (currentUser) {
    if (currentUser) {
      next();
    } else {
      next({ path: '/login' });
    }
  }).catch(function () {
    next({ path: '/login' });
  });
}

function isFirstTime(to, from, next) {
  __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].dispatch('CURRENT_USER').then(function (currentUser) {
    if (currentUser) {
      next({ path: '/home' });
    } else {
      next();
    }
  }).catch(function () {
    next();
  });
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a,
    beforeEnter: isFirstTime
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__views_LoginView___default.a
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__views_HomeView___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/areas',
    name: 'Areas',
    component: __WEBPACK_IMPORTED_MODULE_5__views_AreaView___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/structures',
    name: 'Structures',
    component: __WEBPACK_IMPORTED_MODULE_6__views_StructureView___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/photos',
    name: 'Photos',
    component: __WEBPACK_IMPORTED_MODULE_7__views_PhotosView___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/camera',
    name: 'Camera',
    component: __WEBPACK_IMPORTED_MODULE_8__views_CameraView___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/sync',
    name: 'Sync',
    component: __WEBPACK_IMPORTED_MODULE_9__views_SyncView___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/queue',
    name: 'Queue',
    component: __WEBPACK_IMPORTED_MODULE_10__views_SyncQueue___default.a,
    beforeEnter: requireAuth
  }, {
    path: '/syncArea',
    name: 'SyncArea',
    component: __WEBPACK_IMPORTED_MODULE_11__views_SyncAreaPhotos___default.a,
    beforeEnter: requireAuth
  }]
}));

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 344:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(825),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchUserBlhs;
/* harmony export (immutable) */ __webpack_exports__["i"] = fetchBLH;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchProcess;
/* harmony export (immutable) */ __webpack_exports__["f"] = createProcess;
/* harmony export (immutable) */ __webpack_exports__["g"] = setProcess;
/* harmony export (immutable) */ __webpack_exports__["h"] = syncProcess;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteImage;
/* harmony export (immutable) */ __webpack_exports__["c"] = setImage;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchImage;
/* unused harmony export fetchImages */
/* harmony export (immutable) */ __webpack_exports__["k"] = fetchEquipments;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveFile;
/* harmony export (immutable) */ __webpack_exports__["n"] = isAuthenticated;
/* harmony export (immutable) */ __webpack_exports__["m"] = logoutUser;
/* harmony export (immutable) */ __webpack_exports__["l"] = authenticateUser;
/* harmony export (immutable) */ __webpack_exports__["p"] = fetchAreas;
/* harmony export (immutable) */ __webpack_exports__["o"] = fetchConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_is_js__);





__WEBPACK_IMPORTED_MODULE_2_parse___default.a.serverURL = 'https://certificacaorblh.iff.fiocruz.br/parse';
__WEBPACK_IMPORTED_MODULE_2_parse___default.a.initialize('CQBLH', 'JSKCQBLH');

var logRequests = __webpack_require__.i({"NODE_ENV":"production"}).DEBUG_MODE;

function fetchFromCache(child) {
  logRequests && console.log('fetching ' + child + '...');
  return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.getItem(child).then(function (cacheChild) {
    if (cacheChild) {
      logRequests && console.log('cache hit for ' + child + '.');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(cacheChild);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('O objeto n\xE3o existe ou est\xE1 corrompido.');
      // return new Promise((resolve, reject) => {
      //   var childObject = Parse.Object.extend(child)
      //   var query = new Parse.Query(childObject)
      //   if (id) {
      //     query.get(id).then(childSnapshot => {
      //       if (childSnapshot) {
      //         childSnapshot.__lastUpdated = Date.now()
      //         localforage.setItem(child + '/' + id, childSnapshot)
      //         logRequests && console.log(`fetched ${child} id:${id}.`)
      //       }
      //       resolve(childSnapshot)
      //     })
      //   } else {
      //     query.find().then(childSnapshot => {
      //       if (childSnapshot) {
      //         localforage.setItem(child, childSnapshot)
      //         logRequests && console.log(`fetched ${child}`)
      //       }
      //       resolve(childSnapshot)
      //     })
      //   }
      // api.child(child).once('value', snapshot => {
      //   const val = snapshot.val()
      //   if (val) {
      //     val.__lastUpdated = Date.now()
      //     localforage.setItem(child, val)
      //     logRequests && console.log(`fetched ${child}.`)
      //   }
      //   resolve(val)
      // }, reject)
      // })
    }
  });
}

// Save locally on device storage
function save(child, val) {
  logRequests && console.log('saving ' + child + '...');
  return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem(child, val).then(function (value) {
    logRequests && console.log('cache updated ' + child + '...');
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(val);
  }).catch(function (err) {
    logRequests && console.log('error occurred while updating cache for: ' + child + '...');
    console.log(err.name);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
}

// function push (child, val) {
//   logRequests && console.log(`creating ${child}...`)
//   return localforage.setItem(child, val).then(value => {
//     logRequests && console.log(`cache created ${child}...`)
//     return Promise.resolve(val)
//     // return api.child(child).set(val).then(() => {
//     //   logRequests && console.log(`firebase created ${child}...`)
//     //   return Promise.resolve(val)
//     // })
//   })
// }

// function set(child, val) {
//   logRequests && console.log(`setting ${child}...`)

// return api
//   .child(child)
//   .set(val)
//   .then(() => {
//     logRequests && console.log(`first firebase ${child} setted...`)
//     return localforage.setItem(child, val).then(value => {
//       logRequests && console.log(`then cache setted ${child}...`)
//       return Promise.resolve(val)
//     })
//   })
// }
function fetchUserBlhs(userId) {
  logRequests && console.log('fetch user blh data...');
  var childPath = 'user_blh/' + userId;
  // first try fetching from internet
  if (__WEBPACK_IMPORTED_MODULE_3_is_js___default.a.online()) {
    var Blh = __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('blh');
    var query = new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Blh);
    query.equalTo('userAdministrator', userId);
    return query.find().then(function (blhsSnapshot) {
      var blhs = [];
      blhsSnapshot.forEach(function (blhSnapshot) {
        var blh = {};
        blh.id = blhSnapshot.id;
        blh.currentYear = blhSnapshot.get('currentYear');
        blh.name = blhSnapshot.get('name');
        blh.userAdministrator = blhSnapshot.get('userAdministrator');
        blhs.push(blh);
      });
      return save(childPath, blhs);
    }).catch(function () {
      return fetchFromCache(childPath).then(function (blhs) {
        console.log('USER BLHS from CACHE', blhs);
        return blhs;
      });
    });
  } else {
    return fetchFromCache(childPath).then(function (blhs) {
      console.log('USER BLHS from CACHE', blhs);
      return blhs;
    });
  }
}

function fetchBLH(administratorId) {
  logRequests && console.log('fetch blh data...');
  var childPath = 'blh/' + administratorId;
  return fetchFromCache(childPath).then(function (blh) {
    console.log('BLH HIT FROM CACHE', blh);
    return blh;
  }).catch(function () {
    var Blh = __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('blh');
    var query = new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Blh);
    query.equalTo('userAdministrator', administratorId);
    return query.first().then(function (blhSnapshot) {
      var blh = {};
      blh.id = blhSnapshot.id;
      blh.currentYear = blhSnapshot.get('currentYear');
      blh.name = blhSnapshot.get('name');
      blh.userAdministrator = blhSnapshot.get('userAdministrator');
      return save(childPath, blh);
    });
  });
}

function fetchProcess(year, blhId) {
  logRequests && console.log('fetch process data...');
  // TODO: we should check for the latest version on the database first
  var childPath = 'certification_process/' + year + '/' + blhId;
  return fetchFromCache(childPath).then(function (process) {
    console.log('Process hit from cache', process);
    return process;
  });
  /* return fetchFromCache(childPath).then(cachedProcess => {
    if (!cachedProcess) {
      return Promise.reject('Process not found')
    }
      if (is.online()) {
      var CertificationProcess = Parse.Object.extend('certification_process')
      var query = new Parse.Query(CertificationProcess)
      query.equalTo('blh', blhId)
      query.equalTo('year', year)
      query.greaterThan('syncedAt', cachedProcess.syncedAt)
      query.first().then(processSnapshot => {
        let syncedProcess = {}
        })
    }
    return Promise.resolve(cachedProcess)
  })
  if (is.online()) {
    // fetch from cloud
    var CertificationProcess = Parse.Object.extend('certification_process')
    var query = new Parse.Query(CertificationProcess)
    query.equalTo('blh', blhId)
    query.equalTo('year', year)
    return query.first().then(processSnap => {
      var process = {}
      if (!processSnap) {
        console.log('Process not found on cloud', processSnap)
        return null
      } else {
        process = processSnap.get('process')
        console.log('Process retrieved from cloud', process)
        return save(childPath, process)
      }
    }).catch((error) => {
      console.log(error)
      return fetchFromCache(childPath)
        .then(process => {
          console.log('Process hit from cache', process)
          return process
        })
    })
  } else {
    return fetchFromCache(childPath)
      .then(process => {
        console.log('Process hit from cache', process)
        return process
      })
  }
  */
}

function createProcess(year, blhId) {
  logRequests && console.log('creating new certification process...');
  var certificationProcess = { status: 0, areas: [], id: ''
    // if (is.online()) {
    //   return syncProcess(year, blhId, certificationProcess)
    // } else {
  };return save('certification_process/' + year + '/' + blhId, certificationProcess);
  // }
}

function setProcess(year, blhId, certificationProcess) {
  logRequests && console.log('saving process data...' + certificationProcess);
  // if (is.online()) {
  //   return syncProcess(year, blhId, certificationProcess)
  // } else {
  return save('certification_process/' + year + '/' + blhId, certificationProcess);
  // }
}

function syncProcess(year, blhId, certificationProcess) {
  logRequests && console.log('syncing process data...');
  var CertificationProcess = __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('certification_process');
  var ProcessObj = new CertificationProcess();
  if (certificationProcess.id) {
    var query = new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(CertificationProcess);
    return query.get(certificationProcess.id).then(function (certObj) {
      ProcessObj = certObj;
      certificationProcess.id = ProcessObj.id;
      ProcessObj.set('process', certificationProcess);
      ProcessObj.set('year', year);
      ProcessObj.set('blh', blhId);
      return ProcessObj.save().then(function (process) {
        return save('certification_process/' + year + '/' + blhId, certificationProcess);
      });
    });
  } else {
    ProcessObj.set('process', certificationProcess);
    ProcessObj.set('year', year);
    ProcessObj.set('blh', blhId);
    return ProcessObj.save().then(function (process) {
      certificationProcess.id = process.id;
      ProcessObj.set('process', certificationProcess);
      return ProcessObj.save().then(function () {
        return save('certification_process/' + year + '/' + blhId, certificationProcess);
      });
    });
  }
  // return set(`certification_process/${year}/${uid}`, certificationProcess)
}

function deleteImage(id) {
  return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.removeItem('image/' + id);
}

function setImage(id, image) {
  logRequests && console.log('saving image data...');
  return save('image/' + id, image);
}

function fetchImage(id) {
  logRequests && console.log('fetching image data...');
  return fetchFromCache('image/' + id);
}

function fetchImages(ids) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(ids.map(function (id) {
    return fetchImage(id);
  }));
}

function fetchEquipments() {
  logRequests && console.log('fetch equipment data...');
  // First fetch from internet, then from cache
  if (__WEBPACK_IMPORTED_MODULE_3_is_js___default.a.online()) {
    var Equipments = __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('equipments');
    var query = new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Equipments);
    return query.ascending('name').find().then(function (equipmentList) {
      var equipmentArray = [equipmentList.length];
      for (var i = 0; i < equipmentList.length; i++) {
        var equipment = {};
        equipment.name = equipmentList[i].get('name');
        equipment.photos = equipmentList[i].get('photos');
        equipment.id = equipmentList[i].id;
        equipment.index = i;
        equipmentArray[i] = equipment;
      }
      return save('equipments/', equipmentArray);
    }).catch(function () {
      return fetchFromCache('equipments/');
    });
  } else {
    return fetchFromCache('equipments/');
  }
}

function saveFile(file, name) {
  var parseFile = new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.File(name, file);

  return parseFile.save().then(function (file) {
    console.log(file.url());
    return file.url();
  });
}

function isAuthenticated() {
  logRequests && console.log('fetch current user...');
  var currentUser = __WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.current();
  return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.getItem('uid').then(function (localUser) {
    logRequests && console.log('localUser from cache:' + localUser);
    if (localUser) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(localUser);
    } else if (currentUser) {
      logRequests && console.log('localUser from firebase:' + currentUser);
      return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem('uid', currentUser.id);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(false);
    }
  });
}

function logoutUser() {
  return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem('uid', null).then(function () {
    return __WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.logOut();
  });
}

function authenticateUser(email, password) {
  logRequests && console.log('authenticating ' + email + '...');
  logRequests && console.log('reaching firebase for ' + email + '...');
  return __WEBPACK_IMPORTED_MODULE_2_parse___default.a.User.logIn(email, password).then(function (user) {
    console.log(user);
    logRequests && console.log('authentication success for ' + email + ' uid:' + user.id + ' ');
    return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem('uid', user.id);
  }).catch(function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
}

function fetchAreas() {
  logRequests && console.log('fetch areas data...');
  // First fetch from internet, then from cache
  var Areas = __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Object.extend('areas');
  var query = new __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Query(Areas);
  return query.ascending('name').find().then(function (areasList) {
    var areasArray = [areasList.length];
    for (var i = 0; i < areasList.length; i++) {
      var area = {};
      area.name = areasList[i].get('name');
      area.required = areasList[i].get('required');
      area.id = areasList[i].id;
      area.index = i;
      areasArray[i] = area;
    }
    return save('areas/', areasArray);
  }).catch(function () {
    return fetchFromCache('areas/');
  });
}

function fetchConfig(config) {
  logRequests && console.log('fetching parse config ' + config);
  if (__WEBPACK_IMPORTED_MODULE_3_is_js___default.a.online()) {
    return __WEBPACK_IMPORTED_MODULE_2_parse___default.a.Config.get().then(function (configSnapshot) {
      var returnedConfig = configSnapshot.get(config);
      logRequests && console.log('parse config-' + config + ' fetched: ' + returnedConfig + ' ');
      return save('configs/' + config + '/', returnedConfig);
    }).catch(function () {
      return fetchFromCache('configs/' + config + '/');
    });
  } else {
    return fetchFromCache('configs/' + config + '/');
  }
}

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_css__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_localforage__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_interactjs__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_interactjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_interactjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_croppa_dist_vue_croppa_css__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_croppa_dist_vue_croppa_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_croppa_dist_vue_croppa_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_croppa__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_croppa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_croppa__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_croppa___default.a);
// import 'leaflet/dist/leaflet.css'
// import Vue2Leaflet from 'vue2-leaflet'
// Vue.use(Vue2Leaflet)
// import VueWorker from 'vue-worker'
// Vue.use(VueWorker)
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype, '$interact', { value: __WEBPACK_IMPORTED_MODULE_8_interactjs___default.a });
__WEBPACK_IMPORTED_MODULE_7_localforage___default.a.config({
  name: 'blhcertificationprocess'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme({
  default: {
    primary: {
      color: 'amber',
      hue: 900
    },
    accent: 'indigo'
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_guid__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(391);






var logRequests = __webpack_require__.i({"NODE_ENV":"production"}).DEBUG_MODE;
/* harmony default export */ __webpack_exports__["a"] = ({
  CREATE_AREA: function CREATE_AREA(_ref, area) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;

    var newArea = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, area);
    var proc = state.certificationProcess;
    if (!proc.areas || proc.areas.length <= 0) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc, 'areas', []);
      newArea.id = 0;
      proc.status = 2;
    } else {
      newArea.id = proc.areas.length;
    }

    if (proc.status > 4) proc.status = 4;

    proc.areas.push(newArea);
    return dispatch('SET_PROCESS', proc);
  },
  SET_AREA: function SET_AREA(_ref2, _ref3) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;
    var area = _ref3.area,
        key = _ref3.key;

    var newArea = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, area);
    var proc = state.certificationProcess;
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas, key, newArea);
    return dispatch('SET_PROCESS', proc);
  },
  REMOVE_AREA: function REMOVE_AREA(_ref4, key) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        state = _ref4.state;

    var proc = state.certificationProcess;
    proc.areas.splice(key, 1);
    if (proc.areas.length <= 0) {
      proc.status = 1;
    } else {
      // verify if all areas status equals 1 and se it to 5
      var allAreasDone = true;
      for (var i = 0; i < proc.areas.length; i++) {
        var area = proc.areas[i];
        if (area.status == null || area.status === 0) allAreasDone = false;
      }
      if (allAreasDone) {
        proc.status = 5;
      }
    }
    commit('SET_CURRENT_PHOTO_AREA', 0);
    return dispatch('SET_PROCESS', proc);
  },
  CREATE_STRUCTURE: function CREATE_STRUCTURE(_ref5, _ref6) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        state = _ref5.state;
    var structure = _ref6.structure,
        areaKey = _ref6.areaKey;

    var proc = state.certificationProcess;
    structure.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_guid__["a" /* newGUID */])();
    if (!proc.areas[areaKey].structures || proc.areas[areaKey].structures.length <= 0) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaKey], 'structures', []);
    }
    if (proc.status < 3) {
      proc.status = 3;
    } else {
      proc.status = 4;
    }
    proc.areas[areaKey].status = 0; // aways reset area status uppon adding new equipments
    proc.areas[areaKey].structures.push(structure);
    return dispatch('SET_PROCESS', proc);
  },
  SET_STRUCTURE: function SET_STRUCTURE(_ref7, _ref8) {
    var dispatch = _ref7.dispatch,
        state = _ref7.state;
    var structure = _ref8.structure,
        areaKey = _ref8.areaKey,
        structureKey = _ref8.structureKey;

    console.log('set strucure...');
    console.log(structure, areaKey, structureKey);
    var proc = state.certificationProcess;
    proc.areas[areaKey].structures[structureKey] = structure;
    // Vue.set(proc.areas[areaKey], key, structure)
    return dispatch('SET_PROCESS', proc);
  },
  STRUCTURE_SYNC: function STRUCTURE_SYNC(_ref9, _ref10) {
    var dispatch = _ref9.dispatch,
        state = _ref9.state;
    var itemId = _ref10.itemId,
        areaId = _ref10.areaId,
        status = _ref10.status,
        type = _ref10.type;

    var proc = state.certificationProcess;
    if (type === 'vertice') {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaId].vertices[itemId], 'status', status);
    } else {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaId].structures[itemId], 'status', status);
    }
    return dispatch('SET_PROCESS', proc);
  },
  PHOTO_SYNC: function PHOTO_SYNC(_ref11, _ref12) {
    var dispatch = _ref11.dispatch,
        state = _ref11.state;
    var photoId = _ref12.photoId,
        areaId = _ref12.areaId,
        itemId = _ref12.itemId,
        type = _ref12.type,
        status = _ref12.status,
        image = _ref12.image,
        url = _ref12.url;

    var proc = state.certificationProcess;

    if (type === 'vertice') {
      proc.areas[areaId].vertices[itemId].photos[photoId].status = status;
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaId].vertices[itemId].photos[photoId], 'status', status);
      if (url) {
        proc.areas[areaId].vertices[itemId].photos[photoId].url = url;
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaId].vertices[itemId].photos[photoId], 'url', url);
      }
    } else {
      proc.areas[areaId].structures[itemId].photos[photoId].status = status;
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaId].structures[itemId].photos[photoId], 'status', status);
      if (url) {
        proc.areas[areaId].structures[itemId].photos[photoId].url = url;
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaId].structures[itemId].photos[photoId], 'url', url);
      }
    }

    if (status === 2) {
      console.log('not deleting image!!! change this before production');
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* deleteImage */])(image).then(function () {
        return dispatch('SET_PROCESS', proc);
      });
    } else {
      return dispatch('SET_PROCESS', proc);
    }
  },
  REMOVE_STRUCTURE: function REMOVE_STRUCTURE(_ref13, _ref14) {
    var dispatch = _ref13.dispatch,
        state = _ref13.state;
    var areaKey = _ref14.areaKey,
        key = _ref14.key;

    var proc = state.certificationProcess;
    proc.areas[areaKey].structures.splice(key, 1); // removes the structure
    // check if the area has all photos taken alredy
    var vertices = proc.areas[areaKey].vertices;
    var completed = true;
    vertices.forEach(function (item) {
      if (item.status !== 1) {
        completed = false;
      }
    });
    if (completed) {
      proc.areas[areaKey].status = 1;
    } else {
      proc.areas[areaKey].status = 0;
    }

    // check if there is no structure added to the blh
    var structuresQty = 0;
    var areasCompleted = true;
    proc.areas.forEach(function (area) {
      if (area.structures) {
        structuresQty += area.structures.length;
      }

      if (area.status < 1) {
        areasCompleted = false;
      }
    });

    if (structuresQty <= 0) {
      // if there is no structure we rollback to status 2 (waiting for equipment insertion)
      proc.status = 2;
    } else if (areasCompleted && proc.status < 5) {
      proc.status = 5; // if all areas are completed we can proceed to the next step
    }

    return dispatch('SET_PROCESS', proc);
  },
  UPLOAD_FILE: function UPLOAD_FILE(_ref15, _ref16) {
    var dispatch = _ref15.dispatch,
        state = _ref15.state;
    var image = _ref16.image,
        name = _ref16.name;

    console.log(image);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["b" /* saveFile */])(image, name).then(function (url) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(url);
    }).catch(function (err) {
      console.log(err);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(err));
    });
  },
  ADD_IMAGE: function ADD_IMAGE(_ref17, image) {
    var dispatch = _ref17.dispatch,
        state = _ref17.state;

    var imageId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_guid__["a" /* newGUID */])();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["c" /* setImage */])(imageId, image).then(function () {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(imageId);
    }).catch(function (err) {
      throw err;
    });
  },
  SET_IMAGE: function SET_IMAGE(_ref18, _ref19) {
    var dispatch = _ref18.dispatch,
        state = _ref18.state;
    var id = _ref19.id,
        image = _ref19.image;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["c" /* setImage */])(id, image).then(function () {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(id);
    }).catch(function (err) {
      throw err;
    });
  },
  FETCH_IMAGE: function FETCH_IMAGE(_ref20, imageId) {
    var dispatch = _ref20.dispatch,
        state = _ref20.state;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["d" /* fetchImage */])(imageId);
  },
  SET_PHOTO: function SET_PHOTO(_ref21, _ref22) {
    var dispatch = _ref21.dispatch,
        state = _ref21.state;
    var areaKey = _ref22.areaKey,
        type = _ref22.type,
        structureKey = _ref22.structureKey,
        photoKey = _ref22.photoKey,
        image = _ref22.image;

    var proc = state.certificationProcess;
    if (type === 'vertice') {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaKey].vertices[structureKey].photos[photoKey], 'image', image);
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaKey].vertices[structureKey].photos[photoKey], 'status', 1);
    } else {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaKey].structures[structureKey].photos[photoKey], 'image', image);
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaKey].structures[structureKey].photos[photoKey], 'status', 1);
    }

    var emptyPhotos = 0;
    for (var areaIndex = 0; areaIndex < proc.areas.length; areaIndex++) {
      var area = proc.areas[areaIndex];
      var emptyArea = 0;

      if (area.structures) {
        for (var structureIndex = 0; structureIndex < area.structures.length; structureIndex++) {
          var structure = area.structures[structureIndex];
          var structurePhotos = 0;
          if (structure.photos) {
            for (var photoIndex = 0; photoIndex < structure.photos.length; photoIndex++) {
              var photo = structure.photos[photoIndex];
              if (!photo.image || photo.image === '') {
                emptyPhotos += 1;
                emptyArea += 1;
                structurePhotos += 1;
              }
            }
            if (structurePhotos <= 0) {
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaIndex].structures[structureIndex], 'status', 1);
            }
          }
        }
      }

      if (area.vertices) {
        for (var verticeIndex = 0; verticeIndex < area.vertices.length; verticeIndex++) {
          var vertice = area.vertices[verticeIndex];
          var verticePhotos = 0;
          if (vertice.photos) {
            for (var _photoIndex = 0; _photoIndex < vertice.photos.length; _photoIndex++) {
              var _photo = vertice.photos[_photoIndex];
              if (!_photo.image || _photo.image === '') {
                emptyPhotos += 1;
                emptyArea += 1;
                verticePhotos += 1;
              }
            }
            if (verticePhotos <= 0) {
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaIndex].vertices[verticeIndex], 'status', 1);
            } else {
              __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaIndex].vertices[verticeIndex], 'status', 0);
            }
          }
        }
      }

      if (emptyArea <= 0) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaIndex], 'status', 1);
      } else {
        // IF we set a photo and the are was alrady synced we need to sync it again
        if (proc.areas[areaIndex].status > 1) {
          __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(proc.areas[areaIndex], 'status', 1);
        }
      }
    }
    if (emptyPhotos <= 0) {
      proc.status = 5;
    } else {
      proc.status = 4;
    }
    return dispatch('SET_PROCESS', proc);
  },
  FETCH_PROCESS: function FETCH_PROCESS(_ref23, _ref24) {
    var commit = _ref23.commit,
        state = _ref23.state;
    var blhId = _ref24.blhId,
        year = _ref24.year;

    return state.certificationProcess ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.certificationProcess) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["e" /* fetchProcess */])(year, blhId).then(function (proc) {
      commit('SET_PROCESS', proc);
      if (proc) {
        commit('SET_STEP', proc.status);
      } else {
        commit('SET_STEP', 0);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proc);
    }).catch(function () {
      commit('SET_STEP', 0);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    });
  },
  CREATE_PROCESS: function CREATE_PROCESS(_ref25) {
    var commit = _ref25.commit,
        state = _ref25.state;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["f" /* createProcess */])(state.blh.currentYear, state.blh.id).then(function (proc) {
      commit('SET_PROCESS', proc);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proc);
    });
  },
  SET_PROCESS: function SET_PROCESS(_ref26, process) {
    var commit = _ref26.commit,
        state = _ref26.state;

    var newproc = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, process);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["g" /* setProcess */])(state.blh.currentYear, state.blh.id, newproc).then(function (proc) {
      commit('SET_PROCESS', proc);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proc);
    });
  },
  SYNC_PROCESS: function SYNC_PROCESS(_ref27, blueprintUrl) {
    var commit = _ref27.commit,
        state = _ref27.state;

    var proc = state.certificationProcess;
    proc.blueprintUrl = blueprintUrl;
    proc.status = 7;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["h" /* syncProcess */])(state.blh.currentYear, state.blh.id, proc).then(function (proc) {
      commit('SET_PROCESS', proc);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proc);
    });
  },
  SYNC_TEMP_PROCESS: function SYNC_TEMP_PROCESS(_ref28, process) {
    var commit = _ref28.commit,
        state = _ref28.state;

    var newProc = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, process);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["h" /* syncProcess */])(state.blh.currentYear, state.blh.id, newProc).then(function (proc) {
      commit('SET_PROCESS', proc);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(proc);
    });
  },
  SET_BLH: function SET_BLH(_ref29, _ref30) {
    var commit = _ref29.commit,
        state = _ref29.state;
    var blh = _ref30.blh;

    console.log('SETTING BLH:', blh);
    commit('SET_BLH', blh);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(blh);
  },
  FETCH_BLH: function FETCH_BLH(_ref31, _ref32) {
    var commit = _ref31.commit,
        state = _ref31.state;
    var uid = _ref32.uid;

    return state.blh ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.blh) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["i" /* fetchBLH */])(uid).then(function (blh) {
      console.log('FETCHED BLH:', blh);
      commit('SET_BLH', blh);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(blh);
    });
  },
  FETCH_USER_BLHS: function FETCH_USER_BLHS(_ref33) {
    var commit = _ref33.commit,
        state = _ref33.state;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["j" /* fetchUserBlhs */])(state.uid);
  },
  FETCH_DATA: function FETCH_DATA(_ref34) {
    var dispatch = _ref34.dispatch,
        state = _ref34.state;

    // return dispatch('FETCH_BLH', { uid: state.uid }).then(() => {
    var promises = [];
    var params = {
      blhId: state.blh.id,
      administratorId: state.blh.administratorId,
      year: state.blh.currentYear
    };
    promises.push(dispatch('FETCH_PROCESS', params));
    promises.push(dispatch('FETCH_EQUIPMENT_LIST', params));
    promises.push(dispatch('FETCH_AREAS'));
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
    // })
  },
  FETCH_EQUIPMENT_LIST: function FETCH_EQUIPMENT_LIST(_ref35) {
    var commit = _ref35.commit,
        state = _ref35.state;

    return state.equipmentList[0] ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.equipmentList) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["k" /* fetchEquipments */])().then(function (eq) {
      commit('SET_EQUIPMENT_LIST', eq);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(eq);
    });
  },
  LOGIN: function LOGIN(_ref36, credentials) {
    var commit = _ref36.commit,
        state = _ref36.state;

    commit('LOGIN');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["l" /* authenticateUser */])(credentials.email.toLowerCase(), credentials.password).then(function (uid) {
      commit('LOGIN_SUCCESS', uid);
      logRequests && console.log('login success...');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(uid);
    });
  },
  LOGOUT: function LOGOUT(_ref37) {
    var commit = _ref37.commit,
        state = _ref37.state;

    commit('LOGOUT');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["m" /* logoutUser */])();
  },
  CURRENT_USER: function CURRENT_USER(_ref38) {
    var commit = _ref38.commit,
        state = _ref38.state;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["n" /* isAuthenticated */])().then(function (uid) {
      commit('LOGIN_SUCCESS', uid);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(uid);
    });
  },
  GOTO_STEP: function GOTO_STEP(_ref39, step) {
    var commit = _ref39.commit;

    commit('GOTO_STEP', step);
  },
  SET_PHOTO_AREA: function SET_PHOTO_AREA(_ref40, areaIndex) {
    var commit = _ref40.commit;

    commit('SET_CURRENT_PHOTO_AREA', areaIndex);
  },
  SET_PHOTO_TYPE: function SET_PHOTO_TYPE(_ref41, type) {
    var commit = _ref41.commit;

    commit('SET_CURRENT_PHOTO_TYPE', type);
  },
  FETCH_CONFIG: function FETCH_CONFIG(_ref42, config) {
    var commit = _ref42.commit;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["o" /* fetchConfig */])(config);
  },
  FETCH_AREAS: function FETCH_AREAS(_ref43) {
    var commit = _ref43.commit,
        state = _ref43.state;

    return state.areasList[0] ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(state.areasList) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__api__["p" /* fetchAreas */])().then(function (areas) {
      commit('SET_AREAS_LIST', areas);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(areas);
    });
  },
  SET_CONTINUE_WITH_MINIMUM: function SET_CONTINUE_WITH_MINIMUM(_ref44) {
    var commit = _ref44.commit;

    console.log('SET_CONTINUE_WITH_MINIMUM');
    commit('SET_CONTINUE_WITH_MINIMUM');
  }
});

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_BLH: function SET_BLH(state, blh) {
    state.blh = blh;
  },
  SET_PROCESS: function SET_PROCESS(state, proc) {
    state.certificationProcess = proc;
  },
  SET_EQUIPMENT_LIST: function SET_EQUIPMENT_LIST(state, _equipmentList) {
    state.equipmentList = _equipmentList;
  },

  LOGIN: function LOGIN(state) {
    state.pending = true;
  },
  LOGIN_SUCCESS: function LOGIN_SUCCESS(state, uid) {
    state.uid = uid;
    state.pending = false;
  },
  LOGOUT: function LOGOUT(state) {
    state.uid = null;
    state.blh = null;
    state.certificationProcess = null;
  },
  GOTO_STEP: function GOTO_STEP(state, stepIndex) {
    state.step = stepIndex;
  },
  SET_STEP: function SET_STEP(state, status) {
    if (status < 4) {
      state.step = 0;
    } else if (status < 5) {
      state.step = 1;
    } else if (status < 6) {
      state.step = 2;
    } else {
      state.step = 3;
    }
  },
  SET_CURRENT_PHOTO_AREA: function SET_CURRENT_PHOTO_AREA(state, areaIndex) {
    console.log('SET_CURRENT_PHOTO_AREA' + areaIndex);
    state.currPhotoArea = areaIndex;
  },
  SET_CURRENT_PHOTO_TYPE: function SET_CURRENT_PHOTO_TYPE(state, type) {
    state.currPhotoType = type;
  },
  SET_AREAS_LIST: function SET_AREAS_LIST(state, _areasList) {
    state.areasList = _areasList;
  },

  SET_CONTINUE_WITH_MINIMUM: function SET_CONTINUE_WITH_MINIMUM(state) {
    state.continueWithMinimum = true;
  }
});

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newGUID; });
var newGUID = function newGUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    blh: function blh(state) {
      return state.blh;
    }
  }), {
    user: function user() {
      return {};
    },
    memoryAvaiable: function memoryAvaiable() {},
    userAgent: function userAgent() {},
    title: function title() {
      var name = '';
      if (this.blh) {
        name = ' ' + this.blh.name.trim();
      }
      switch (this.$route.path) {
        case '/areas':
          return 'Instalações' + name;
        case '/structures':
          return 'Equipamentos' + name;
        case '/photos':
          return 'Fotos' + name;
        default:
          return name;
      }
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    toolbarActive: function toolbarActive() {
      var path = this.$route.path;
      return path !== '/' && path !== '/camera';
    }
  }),
  // beforeMount(){
  //     let vm = this
  //     navigator.webkitTemporaryStorage.queryUsageAndQuota(
  //       function(usedBytes, grantedBytes) {
  //         console.log('we are using ', usedBytes, ' of ', grantedBytes, 'bytes')
  //         if (grantedBytes - usedBytes <= 4000000) {
  //           console.log('TAMANHO INSUFICIENTE PARA PROSSEGUIR COM O PROCESSO')
  //           vm.quotaExceeded = true
  //         } else {
  //           vm.quotaExceeded = false
  //         }
  //       },
  //       function(e) {
  //         console.log('Error', e)
  //         vm.quotaExceeded = true
  //       }
  //     )
  // },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['LOGOUT']), {
    isRouterPath: function isRouterPath(page) {
      var path = this.$route.path;
      return path.indexOf('/' + page) === 0 || path === page;
    },
    logout: function logout() {
      var _this = this;

      this.LOGOUT().then(function () {
        _this.$router.push('/');
      });
    },
    sync: function sync() {
      this.$router.push('sync');
    },
    formatBytes: function formatBytes(a, b) {
      if (a === 0) return '0 Bytes';
      var c = 1024;
      var d = b || 2;
      var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var f = Math.floor(Math.log(a) / Math.log(c));
      return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
    }
  })
});

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addAreaDialog',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    areaList: function areaList(state) {
      return state.areasList;
    }
  })),
  data: function data() {
    return {
      area: {
        name: '',
        // description: '',
        x: 0,
        y: 0,
        w: 100,
        h: 100,
        conformidade: [],
        tipoPiso: '',
        tipoTeto: '',
        tipoParede: ''
      },
      areakey: null,
      itensRDC50: [{ id: 1, name: 'Piso' }, { id: 2, name: 'Teto' }, { id: 3, name: 'Parede' }, { id: 4, name: 'Rodapé' }, { id: 5, name: 'Luminária' }, { id: 6, name: 'Janela' }, { id: 7, name: 'Portas' }, { id: 8, name: 'Ralo' }, { id: 9, name: 'Climatização' }, { id: 10, name: 'Conservação do Ambiente' }]
    };
  },
  beforeMount: function beforeMount() {
    this.FETCH_AREAS();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['CREATE_AREA', 'SET_AREA', 'REMOVE_AREA', 'FETCH_AREAS']), {
    open: function open() {
      this.reset();
      this.$refs.add_area_dialog.open();
    },
    edit: function edit(_area, _areakey) {
      this.area = _area;
      this.areakey = _areakey;
      this.$refs.add_area_dialog.open();
    },
    close: function close() {
      this.$refs.add_area_dialog.close();
    },
    reset: function reset() {
      this.areakey = null;
      this.area = {
        name: '',
        // description: '',
        x: 0,
        y: 0,
        w: 100,
        h: 100,
        conformidade: [],
        // vertices: [],
        tipoParede: '',
        tipoPiso: '',
        tipoTeto: ''
      };
    },
    removeArea: function removeArea() {
      this.$refs.add_area_dialog.close();
      this.REMOVE_AREA(this.areakey);
    },
    saveArea: function saveArea() {
      this.$refs.add_area_dialog.close();
      this.SET_AREA({ area: this.area, key: this.areakey });
    },
    addArea: function addArea() {
      this.$refs.add_area_dialog.close();
      this.CREATE_AREA(this.area);
    }
  })
});

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(22);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'addStructureDialog',
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    equipmentList: function equipmentList(state) {
      return state.equipmentList;
    }
  })),
  data: function data() {
    return {
      currentArea: 0,
      structure: -1,
      currentItemKey: null,
      id: '',
      name: '',
      type: null,
      description: '',
      patrimony: '',
      model: '',
      brand: '',
      x: 0,
      y: 0,
      photos: [],
      isLoading: false
    };
  },
  props: ['activeProcess'],
  beforeMount: function beforeMount() {
    this.FETCH_EQUIPMENT_LIST();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['FETCH_EQUIPMENT_LIST', 'CREATE_STRUCTURE', 'SET_STRUCTURE', 'REMOVE_STRUCTURE']), {
    openDialog: function openDialog(_areaKey, _item, _key) {
      if (_item) {
        this.name = _item.name;
        this.type = _item.type;
        this.id = _item.id;
        this.description = _item.description;
        this.patrimony = _item.patrimony;
        this.model = _item.model;
        this.brand = _item.brand;
        this.x = _item.x;
        this.y = _item.y;
        this.photos = _item.photos;
        if (_item.type === 'equipment') {
          this.structure = _item.structureId;
        } else {
          this.structure = _item.type;
        }
        this.currentItemKey = _key;
      } else {
        this.reset();
      }
      this.currentArea = _areaKey;
      this.$refs.eq_dialog.open();
    },
    close: function close() {
      this.$refs.eq_dialog.close();
    },
    reset: function reset() {
      this.currentItemKey = null;
      this.structure = -1;
      this.id = '';
      this.name = '';
      this.type = null;
      this.description = '';
      this.patrimony = '';
      this.model = '';
      this.brand = '';
      this.x = 0;
      this.y = 0;
      this.photos = [];
    },
    removeItem: function removeItem() {
      var _this = this;

      this.isLoading = true;
      this.REMOVE_STRUCTURE({
        areaKey: this.currentArea,
        key: this.currentItemKey
      }).then(function () {
        _this.isLoading = false;
        _this.close();
      });
    },
    saveItem: function saveItem() {
      var _this2 = this;

      this.isLoading = true;
      var newItem = {
        structureId: null,
        id: this.id,
        name: '',
        type: null,
        description: this.description,
        x: this.x,
        y: this.y,
        patrimony: this.patrimony,
        model: this.model,
        brand: this.brand,
        photos: []
      };

      if (this.structure !== 'hydraulic' && this.structure !== 'eletric') {
        newItem.structureId = this.structure;
        newItem.type = 'equipment';
        newItem.name = this.equipmentList[this.structure].name;
        newItem.patrimony = this.patrimony;
        newItem.model = this.model;
        newItem.brand = this.brand;
        this.equipmentList[this.structure].photos.forEach(function (photo) {
          newItem.photos.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, photo));
        });
      } else {
        newItem.type = this.structure;
        newItem.name = '';
        newItem.type === 'hydraulic' ? 'Ponto Hidráulico' : 'Ponto Elétrico';
        newItem.photos = [{ description: 'total' }];
      }
      // console.log('salvando...')
      // console.log(newItem, this.currentArea, this.currentItemKey)
      this.SET_STRUCTURE({
        structure: newItem,
        areaKey: this.currentArea,
        structureKey: this.currentItemKey
      }).then(function () {
        _this2.isLoading = false;
        _this2.close();
      });
    },
    addItem: function addItem() {
      var _this3 = this;

      this.isLoading = true;
      var newItem = {
        structureId: null,
        id: '',
        name: '',
        patrimony: '',
        model: '',
        brand: '',
        type: null,
        description: this.description,
        x: this.x,
        y: this.y,
        photos: []
      };
      if (this.structure < 0) {
        console.log('STRUTURA UNDEFINED:' + this.structure);
        this.isLoading = false;
        this.close();
        return;
      }

      if (this.structure !== 'hydraulic' && this.structure !== 'eletric') {
        newItem.structureId = this.structure;
        newItem.type = 'equipment';
        newItem.patrimony = this.patrimony;
        newItem.model = this.model;
        newItem.brand = this.brand;
        newItem.name = this.equipmentList[this.structure].name;
        this.equipmentList[this.structure].photos.forEach(function (photo) {
          newItem.photos.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, photo));
        });
      } else {
        newItem.type = this.structure;
        newItem.name = newItem.type === 'hydraulic' ? 'Ponto Hidráulico' : 'Ponto Elétrico';
        newItem.photos = [{ description: 'total' }];
      }

      this.CREATE_STRUCTURE({
        structure: newItem,
        areaKey: this.currentArea
      }).then(function () {
        _this3.isLoading = false;
        _this3.close();
      });
    }
  })
});

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BlueprintDialog__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BlueprintDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BlueprintDialog__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import is from 'is_js'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'area-definition',
  components: {
    BlueprintDialog: __WEBPACK_IMPORTED_MODULE_3__components_BlueprintDialog___default.a
  },
  data: function data() {
    return {
      isSyncingArea: false,
      syncSuccessfull: false,
      hasError: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    uid: function uid(state) {
      return state.uid;
    },
    blh: function blh(state) {
      return state.blh;
    },
    certificationProcess: function certificationProcess(state) {
      return state.certificationProcess;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['SET_PROCESS', 'ADD_IMAGE', 'SET_IMAGE', 'GOTO_STEP', 'UPLOAD_FILE', 'FETCH_IMAGE']), {
    openBlueprintDialog: function openBlueprintDialog() {
      this.$refs.startdialog.openDialog();
    },
    blueprintSelected: function blueprintSelected() {
      var _this = this;

      for (var _len = arguments.length, selectedImageArgs = Array(_len), _key = 0; _key < _len; _key++) {
        selectedImageArgs[_key] = arguments[_key];
      }

      if (!selectedImageArgs) {
        return;
      }

      var _selectedImageArgs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(selectedImageArgs, 3),
          imageBlob = _selectedImageArgs[0],
          imgWidth = _selectedImageArgs[1],
          imgHeight = _selectedImageArgs[2];

      if (!imageBlob) {
        return;
      }

      var _setCertBlueprintImgR = this.setCertBlueprintImgRatio(imgWidth, imgHeight),
          _setCertBlueprintImgR2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_setCertBlueprintImgR, 2),
          bpWidth = _setCertBlueprintImgR2[0],
          bpHeight = _setCertBlueprintImgR2[1];

      // Chegando se já existe um imagem atribuido para a planta


      if (!this.certificationProcess.blueprint) {
        // Caso ainda não exista imagem atribuida para a planta, criamos e adicionamos o blob
        this.ADD_IMAGE(imageBlob).then(function (imageId) {
          // Utilizamos o id da Imagem para efetuar o upload quando necessario
          _this.$set(_this.certificationProcess, 'blueprint', imageId);
          // Já que ainda não existe arquivo pra planta, significa que estamos no primeiro passo, por isso atualizamos o status
          _this.$set(_this.certificationProcess, 'status', 1);

          if (bpWidth > 0) {
            _this.$set(_this.certificationProcess, 'bpWidth', bpWidth);
          }
          if (bpHeight > 0) {
            _this.$set(_this.certificationProcess, 'bpHeight', bpHeight);
          }

          _this.$set(_this.certificationProcess, 'deviceWidth', window.innerWidth);
          _this.$set(_this.certificationProcess, 'deviceHeight', window.innerHeight);
          return _this.SET_PROCESS(_this.certificationProcess);
        });
      } else {
        this.SET_IMAGE({
          id: this.certificationProcess.blueprint,
          image: imageBlob
        }).then(function () {
          // Atualizamos o tamanho da planta para se adequar ao novo arquivo
          if (bpWidth > 0) {
            _this.$set(_this.certificationProcess, 'bpWidth', bpWidth);
          }
          if (bpHeight > 0) {
            _this.$set(_this.certificationProcess, 'bpHeight', bpHeight);
          }
          // Atualizamos o tamanho do aparelho para se adequar ao novo arquivo
          _this.$set(_this.certificationProcess, 'deviceWidth', window.innerWidth);
          _this.$set(_this.certificationProcess, 'deviceHeight', window.innerHeight);
          return _this.SET_PROCESS(_this.certificationProcess);
        });
      }
    },
    setCertBlueprintImgRatio: function setCertBlueprintImgRatio(width, height) {
      var ratio = Math.min(window.innerWidth / width, window.innerHeight / height);
      var bpWidth = Math.round(width * ratio);
      var bpHeight = Math.round(height * ratio);
      return [bpWidth, bpHeight];
    },
    finishArea: function finishArea() {
      this.isSyncingArea = false;

      if (this.certificationProcess.status < 4) {
        this.$set(this.certificationProcess, 'status', 4);
        this.SET_PROCESS(this.certificationProcess);
        this.GOTO_STEP(1);
      } else {
        this.GOTO_STEP(1);
      }
    },
    openAreas: function openAreas() {
      this.$router.push('/areas');
    },
    openStructure: function openStructure() {
      this.$router.push('/structures');
    },
    syncData: function syncData() {
      // this.$refs.snackbar_sync.open()
      // this.isSyncingArea = true
      // if (is.online()) {
      //   this.FETCH_IMAGE(this.certificationProcess.blueprint).then(imgBlob => {
      //     let fileName = `${this.blh.currentYear}_${this.blh.id}_${this.certificationProcess.blueprint}.jpg`
      //
      //     this.UPLOAD_FILE({ image: new File([imgBlob], fileName), name: fileName })
      //       .then((fileUrl) => {
      //         this.syncSuccessfull = true
      //         this.certificationProcess.blueprintUrl = fileUrl
      //
      //         this.SET_PROCESS(this.certificationProcess)
      //       })
      //   }).catch(err => {
      //     this.hasError = err
      //     this.syncSuccessfull = true
      //   })
      // } else {
      //   this.hasError = 'Sem conexão com a internet.'
      //   this.syncSuccessfull = true
      // }
    }
  })
});

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StructureSyncItem__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StructureSyncItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_StructureSyncItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'area-sync-list',
  components: {
    'structure-sync-item': __WEBPACK_IMPORTED_MODULE_0__components_StructureSyncItem___default.a
  },
  props: {
    area: { type: Object, required: true }
  },
  data: function data() {
    return {
      hasStarted: false,
      structureSynced: [],
      verticeSynced: [],
      completed: false
    };
  },

  watch: {
    structureSynced: function structureSynced(newlist) {
      var structureCount = 0;
      if (this.area.structures != null) {
        structureCount = this.area.structures.length;
      }
      if (this.structureSynced.length === structureCount && this.verticeSynced.length === this.area.vertices.length) {
        this.completed = true;
        this.$emit('areaSynced', this.area.id);
      }
    },
    verticeSynced: function verticeSynced(newList) {
      var structureCount = 0;
      if (this.area.structures != null) {
        structureCount = this.area.structures.length;
      }
      if (this.structureSynced.length === structureCount && this.verticeSynced.length === this.area.vertices.length) {
        this.completed = true;
        this.$emit('areaSynced', this.area.id);
      }
    }
  },
  methods: {
    startArea: function startArea() {
      this.hasStarted = true;
    },
    structureSyncHandler: function structureSyncHandler(structureId) {
      if (!this.structureSynced.find(function (id) {
        return id === structureId;
      })) {
        this.structureSynced.push(structureId);
      }
    },
    verticeSyncHandler: function verticeSyncHandler(verticeId) {
      if (!this.verticeSynced.find(function (id) {
        return id === verticeId;
      })) {
        this.verticeSynced.push(verticeId);
      }
    }
  }
});

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'blueprint-dialog',
  props: ['imageId', 'title', 'blueprintUrl'],
  data: function data() {
    return {
      previewSrc: '',
      imgBlob: null,
      isLoading: false,
      imgW: 0,
      imgH: 0
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['FETCH_IMAGE']), {
    onBluePrintSelected: function onBluePrintSelected(fileList) {
      this.isLoading = true;
      var vm = this;
      if (fileList && fileList[0]) {
        var img = new Image();
        img.onload = function () {
          vm.imgW = img.width;
          vm.imgH = img.height;
          vm.previewSrc = img.src;
        };
        vm.isLoading = false;
        vm.imgBlob = fileList[0];
        img.src = window.URL.createObjectURL(fileList[0]);
      }
    },
    confirmSelectedBlueprint: function confirmSelectedBlueprint() {
      this.$emit('select', this.imgBlob, this.imgW, this.imgH);
      this.imgBlob = null;
      this.previewSrc = null;
      this.closeDialog();
    },
    revokeURL: function revokeURL() {
      URL.revokeObjectURL(this.previewSrc);
    },
    loadImage: function loadImage() {
      this.isLoading = false;
      this.previewSrc = URL.createObjectURL(this.imgBlob);
    },
    closeDialog: function closeDialog() {
      if (this.previewSrc) {
        this.imgBlob = null;
        this.previewSrc = null;
      }
      URL.revokeObjectURL(this.previewSrc);
      this.$refs['upload_planta_dialog'].close();
    },
    openDialog: function openDialog() {
      var _this = this;

      // console.log(this.blueprintUrl)
      // if (this.blueprintUrl) {
      //   this.isLoading = false
      //   this.previewSrc = this.blueprintUrl
      //   this.$refs['upload_planta_dialog'].open()
      // } else {
      if (this.imageId) {
        this.isLoading = true;
        this.previewSrc = '';
        this.FETCH_IMAGE(this.imageId).then(function (imageBlob) {
          _this.imgBlob = imageBlob;
          _this.loadImage();
        }).catch(function () {
          _this.isLoading = false;
        });
      } else {
        this.previewSrc = '';
      }
      this.$refs['upload_planta_dialog'].open();
      // }
    }
  })
});

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pica_dist_pica_min__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_pica_dist_pica_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_pica_dist_pica_min__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import ImageCompressor from '@xkeshi/image-compressor'

var resizer = __WEBPACK_IMPORTED_MODULE_2__node_modules_pica_dist_pica_min___default()();
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'camera-image-select',
  props: {
    description: String,
    photoId: Number,
    imageId: { type: String, required: false },
    imageUrl: String
  },
  data: function data() {
    return {
      imgSrc: '',
      // imgBlob: null
      inputfile: '',
      isLoading: true
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.inputfile = '';
    if (this.imageId) {
      this.FETCH_IMAGE(this.imageId).then(function (imgBlob) {
        _this.loadImage(imgBlob);
      }).catch(function (e) {
        console.log('imagem not found');
        if (_this.imageUrl) {
          _this.imgSrc = _this.imageUrl;
        }
      });
    } else {
      if (this.imageUrl) {
        this.imgSrc = this.imageUrl;
      } else {
        this.imgSrc = '';
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['ADD_IMAGE', 'SET_IMAGE', 'FETCH_IMAGE']), {
    handleFileChange: function handleFileChange(e) {
      var vm = this;
      if (e.target.files && e.target.files[0]) {
        var img = new Image();
        img.onload = function () {
          // To scale image we calculate new width and height, resize image by height and crop by width
          var scaledHeight = void 0,
              scaledWidth = void 0;

          scaledHeight = 600;
          scaledWidth = Math.floor(img.width * scaledHeight / img.height);

          var quality = 0; // (ext === 'jpeg' || ext === 'jpg') ? resizeConfig.jpeg_quality : undefined;

          var width = Math.min(img.height * scaledWidth / scaledHeight, img.width);
          var cropX = (width - img.width) / 2;

          var source = document.createElement('canvas');
          var dest = document.createElement('canvas');

          source.width = width;
          source.height = img.height;

          dest.width = scaledWidth;
          dest.height = scaledHeight;

          source.getContext('2d').drawImage(img, cropX, 0, width, img.height);

          resizer.resize(source, dest, { quality: 0, alpha: false, unsharpAmount: 50 }).then(function () {
            return resizer.toBlob(dest, e.target.files[0], quality);
          }).then(function (blob) {
            window.URL.revokeObjectURL(img.src);
            if (!vm.imageId) {
              vm.ADD_IMAGE(blob).then(function (imgId) {
                vm.isLoading = false;
                vm.imgSrc = window.URL.createObjectURL(blob);
                vm.$emit('add', imgId, vm.photoId, vm.imgSrc);
              });
            } else {
              vm.SET_IMAGE({ id: vm.imageId, image: blob }).then(function () {
                vm.isLoading = false;
                vm.imgSrc = window.URL.createObjectURL(blob);
                vm.$emit('add', vm.imageId, vm.photoId, vm.imgSrc);
              });
            }
            // vm.imgBlob = blob
            // vm.previewSrc = window.URL.createObjectURL(blob)
          });
        };
        img.src = window.URL.createObjectURL(e.target.files[0]);
        // let compressor = new ImageCompressor()
        // compressor.compress(e.target.files[0], { quality: 0.6, convertSize: 1000000 }).then(result => {
        //   this.ADD_IMAGE(result).then(imgId => {
        //     vm.loadImage(result)
        //     vm.$emit('add', imgId, vm.photoId)
        //   })
        // })
      }
    },
    revokeURL: function revokeURL() {
      console.log('Image loaded');
      this.isLoading = false;
      // URL.revokeObjectURL(this.imgSrc)
    },
    loadImage: function loadImage(blob) {
      console.log('loading image');
      this.imgSrc = URL.createObjectURL(blob);
      // var fileReader = new FileReader()
      // fileReader.onload = function (e) {
      //   this.imgSrc = e.target.result
      // }.bind(this)
      // fileReader.readAsDataURL(blob)
    },
    clickDelegate: function clickDelegate() {
      this.$emit('select', this.imageId, this.photoId);
    },
    remove: function remove() {
      this.inputfile = '';
      this.imgSrc = '';
    }
  })
});

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_is_js__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'check-requisites',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    continueWithMinimum: function continueWithMinimum(state) {
      return state.continueWithMinimum;
    }
  })),
  data: function data() {
    return {
      storage: '',
      ram: '',
      navigator: '',
      messages: [],
      meetRequisites: true
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (this.continueWithMinimum) {
      console.log('APARELHO NÃO ATENDE E ESCOLHEU SEGUIR EM FRENTE');
      this.meetRequisites = true;
      this.$emit('onRequisitesCheck', this.meetRequisites);
      return;
    }
    this.FETCH_CONFIG('minRam').then(function (minRam) {
      if (!_this.hasMinimumRam(minRam)) {
        _this.meetRequisites = false;
        _this.messages.push('Aparelho possui pouca memória RAM disponível');
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    }).then(function () {
      if (!_this.isChrome()) {
        _this.meetRequisites = false;
        _this.messages.push('Navegador imcompatível, por favor utilize Google Chrome v.71 ou superior.');
      }
    }).then(function () {
      return _this.hasMinimumStorage().then(function (hasStorage) {
        if (!hasStorage) {
          _this.meetRequisites = false;
          _this.messages.push('Aparelho não disponibiliza espaço em disco suficiente para continuar. Tente acessar utilizando o navegador Google Chrome e adicione o endereço do aplicativo ao favoritos.');
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      });
    }).finally(function () {
      _this.$emit('onRequisitesCheck', _this.meetRequisites);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['FETCH_CONFIG', 'SET_CONTINUE_WITH_MINIMUM']), {
    hasMinimumStorage: function hasMinimumStorage() {
      var _this2 = this;

      if (!navigator.storage && !navigator.storage.estimate) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(false);
      }
      return navigator.storage.estimate().then(function (estimate) {
        _this2.storage = _this2.formatBytes(estimate.usage) + ' utilizados de ' + _this2.formatBytes(estimate.quota);
        var usage = estimate.usage / estimate.quota * 100;
        if (usage > 80) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(false);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(true);
        }
      });
    },
    hasMinimumRam: function hasMinimumRam(minRam) {
      if (__WEBPACK_IMPORTED_MODULE_4_is_js___default.a.desktop) {
        return true;
      }

      var MIN_MEMORY_LIMIT = minRam * 1048576; // 1GB
      var MAX_PERCENT_THRESHOLD = 90;

      if (!performance || !performance.memory) {
        return false;
      }

      this.ram = this.formatBytes(performance.memory.jsHeapSizeLimit);

      if (performance.memory.jsHeapSizeLimit < MIN_MEMORY_LIMIT) {
        return false;
      }

      if (performance.memory.usedJSHeapSize > MAX_PERCENT_THRESHOLD / 100 * performance.memory.jsHeapSizeLimit) {
        this.memory += 'Limite de utilização de memória RAM alcançado, feche os aplicativos que não está utilizando para liberar memória e tente novamente.';
        return false;
      }
      return true;
    },
    isChrome: function isChrome() {
      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== 'undefined';
      var isIEedge = winNav.userAgent.indexOf('Edge') > -1;
      var isIOSChrome = winNav.userAgent.match('CriOS');

      if (isIOSChrome) {
        // is Google Chrome on IOS
        this.navigator = 'Google Chrome on IOS';
        return true;
      } else if (isChromium !== null && typeof isChromium !== 'undefined' && vendorName === 'Google Inc.' && isOpera === false && isIEedge === false) {
        // is Google Chrome
        this.navigator = 'Google Chrome';
        return true;
      } else {
        if (__WEBPACK_IMPORTED_MODULE_4_is_js___default.a.desktop) {
          return true;
        } else {
          // not Google Chrome
          this.navigator = winNav.userAgent;
          return false;
        }
      }
    },
    formatBytes: function formatBytes(a, b) {
      if (a === 0) return '0 Bytes';
      var c = 1024;
      var d = b || 2;
      var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var f = Math.floor(Math.log(a) / Math.log(c));
      return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
    },
    notEmptyObject: function notEmptyObject(someObject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(someObject).length;
    },
    continueWithProcess: function continueWithProcess() {
      this.SET_CONTINUE_WITH_MINIMUM();
      this.meetRequisites = true;
      this.$emit('onRequisitesCheck', true);
    }
  })
});

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'draggableArea',
  props: ['value', 'number'],
  computed: {
    areaName: function areaName() {
      var _this = this;

      var words = this.chunkSubstr(this.value.name, 17);
      var tspans = '';
      var y = 0;
      words.forEach(function (chunk) {
        tspans += '<tspan data-key="' + _this.number + '" x="50%" dy=' + y + '>' + chunk + '</tspan>';
        y = 100;
      });
      return tspans;
    }
  },
  methods: {
    chunkSubstr: function chunkSubstr(str, size) {
      var numChunks = Math.ceil(str.length / size);
      var chunks = new Array(numChunks);

      for (var i = 0, o = 0; i < numChunks; ++i, o += size) {
        chunks[i] = str.substr(o, size);
      }

      return chunks;
    }
  }
});

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'draggableStructure',
  props: ['value', 'number']
});

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  methods: {
    login: function login() {
      this.$router.push('/login');
    }
  }
});

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photos-list',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    'certificationProcess': function certificationProcess(state) {
      return state.certificationProcess;
    }
  })),
  beforeMount: function beforeMount() {
    this.FETCH_DATA();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['FETCH_DATA', 'GOTO_STEP']), {
    openPhotos: function openPhotos() {
      this.$router.push('/photos');
    },
    finishPhotos: function finishPhotos() {
      this.GOTO_STEP(2);
    }
  })
});

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'structure-camera-icon',
  props: ['value']
});

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SyncErrorDialog__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SyncErrorDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SyncErrorDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(22);


//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: { SyncErrorDialog: __WEBPACK_IMPORTED_MODULE_2__components_SyncErrorDialog___default.a },
  name: 'StructureSyncItem',
  props: {
    id: Number,
    year: Number,
    itemId: String,
    areaId: Number,
    name: String,
    photos: Array,
    status: Number,
    type: String,
    areaStarted: Boolean
  },
  watch: {
    areaStarted: function areaStarted(newValue, oldValue) {
      if (newValue === true) {
        this.startProcess();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    'uid': function uid(state) {
      return state.uid;
    },
    'blh': function blh(state) {
      return state.blh;
    }
  }), {
    progress: function progress() {
      return this.uploaded / this.photos.length * 100;
    },
    desc: function desc() {
      if (!this.completed) {
        if (!this.hasError) {
          return this.uploaded + ' de ' + this.photos.length + ' imagens enviadas';
        } else {
          return 'Ocorreu um erro ao efetuar o upload';
        }
      } else {
        return 'Imagens sincronizadas com sucesso';
      }
    }
  }),
  data: function data() {
    return {
      uploaded: 0,
      completed: false,
      uploadStatus: '',
      hasError: false,
      error: '',
      photoIndexErrors: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['FETCH_IMAGE', 'STRUCTURE_SYNC', 'PHOTO_SYNC', 'UPLOAD_FILE']), {
    restart: function restart() {
      this.startProcess();
    },
    openErrorDialog: function openErrorDialog() {
      this.$refs.syncErrorDialog.openDialog();
    },
    startProcess: function startProcess() {
      var _this = this;

      this.completed = false;
      this.hasError = false;
      this.error = '';
      this.photoIndexErrors = [];
      this.uploadPhotos().then(function () {
        console.log('[uploadPhotos] END SUCCESS');
        _this.completed = true;
        _this.$emit('structureSynced', _this.itemId);
        _this.STRUCTURE_SYNC({
          areaId: _this.areaId,
          itemId: _this.id,
          type: _this.type,
          status: 2
        }).then(function () {
          _this.$emit('structureSynced', _this.itemId);
        });
      }).catch(function (err) {
        console.log('[uploadPhotos] END WITH ERROR');
        console.log(_this.photoIndexErrors);
        _this.error = err;
      });
    },
    uploadPhotos: function uploadPhotos() {
      var vm = this;
      console.log('[uploadPhotos] START');
      console.log(this.photos);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(this.photos.map(function (photo, photoIndex) {
        console.log('Processing Image ' + photoIndex + ' ' + vm.name);
        if (photo.status === 2) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        }
        return vm.FETCH_IMAGE(photo.image).then(function (imgBlob) {
          console.log('FETCH_IMAGE ' + photoIndex + ' ' + vm.name);
          var fileName = vm.blh.currentYear + '_' + vm.uid + '_' + photo.image + '.png';
          return vm.UPLOAD_FILE({ image: new File([imgBlob], fileName), name: fileName }).then(function (fileUrl) {
            return vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: 2, image: photo.image, url: fileUrl }).then(function () {
              vm.uploaded++;
            });
          }).catch(function (err) {
            vm.hasError = true;
            return vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: -1 }).then(function () {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
            });
          });
        }).catch(function (err) {
          vm.hasError = true;
          var photoError = { name: vm.name, photo: photo, photoId: photoIndex, areaId: vm.areaId, id: vm.id, itemId: vm.itemId, type: vm.type };
          vm.photoIndexErrors.push(photoError);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }));
      // return Promise.all(this.photos.map(function (photo, photoIndex) {
      // if (!photo.status || photo.status !== 2) {
      // if (!photo.status) {
      // return vm.FETCH_IMAGE(photo.image).then(imgBlob => {
      // return new Promise((resolve, reject) => {
      //   var fr = new FileReader()
      //   fr.onload = () => {
      //     var base64 = fr.result.split('base64,')[1]
      //     vm.UPLOAD_FILE({base64: base64, name: `${vm.blh.currentYear}_${vm.uid}_${photo.image}.png`}).then(() => {
      //       vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: 2, image: photo.image })
      //     }).catch(err => {
      //       vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: -1 })
      //       console.log(err)
      //     })
      //     resolve()
      //   }
      //   fr.readAsDataURL(imgBlob)
      // })
      /*
      let task = storage.child(`${vm.blh.currentYear}/${vm.uid}/${photo.image}`).put(imgBlob)
      task.on('state_changed', null, function (err) {
        console.log(vm.id)
        vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: -1 })
        Promise.reject(err)
      }, function () {
        console.log(vm.id)
        vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: 2, image: photo.image })
        vm.uploaded++
      })
      return task
      */
      // })
      // } else {
      // return Promise.resolve()
      // }
      // }))
    }
  })
});

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CameraImageSelect__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CameraImageSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CameraImageSelect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SyncErrorDialog',
  components: {
    CameraImageSelect: __WEBPACK_IMPORTED_MODULE_0__components_CameraImageSelect___default.a
  },
  props: {
    error: String,
    photoErrors: Array
  },
  methods: {
    startProcess: function startProcess() {
      this.$refs['synErrorDialog'].close();
      this.$emit('restart');
    },
    openDialog: function openDialog() {
      this.$refs['synErrorDialog'].open();
    }
  }
});

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AddAreaDialog__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AddAreaDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AddAreaDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DraggableArea__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DraggableArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DraggableArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(22);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'areas',
  components: {
    AddAreaDialog: __WEBPACK_IMPORTED_MODULE_1__components_AddAreaDialog___default.a,
    DraggableArea: __WEBPACK_IMPORTED_MODULE_2__components_DraggableArea___default.a
  },
  beforeDestroy: function beforeDestroy() {
    this.$interact('.draggable').unset();
    this.$interact('.notdraggable').unset();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    'certificationProcess': function certificationProcess(state) {
      return state.certificationProcess;
    }
  })),
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.loaded) {
        _this.calculate();
      }
    });
  },

  data: function data() {
    return {
      blueprint: '',
      bpHeight: 0,
      bpWidth: 0,
      deviceWidth: 0,
      clientWidth: 0,
      clientHeight: 0,
      deviceHeight: 0,
      selected: null,
      loaded: false,
      ratio: 1
    };
  },
  mounted: function mounted() {
    this.calculate();
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.FETCH_DATA().then(function () {
      // if (this.certificationProcess.blueprintUrl) {
      //   this.bpWidth = this.certificationProcess.bpWidth
      //   this.bpHeight = this.certificationProcess.bpHeight
      //   this.blueprint = this.certificationProcess.blueprintUrl
      //   this.deviceWidth = this.certificationProcess.deviceWidth
      //   this.deviceHeight = this.certificationProcess.deviceHeight
      //   this.setInteractive()
      // } else {
      _this2.FETCH_IMAGE(_this2.certificationProcess.blueprint).then(function (imageBlob) {
        _this2.loadBlueprint(imageBlob);
      }).catch(function (error) {
        console.log(error);
      });
      // }
    });
    window.dragMoveListener = this.dragMoveListener;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['FETCH_DATA', 'FETCH_IMAGE', 'SET_AREA', 'SET_PROCESS']), {
    calculate: function calculate() {
      this.clientWidth = this.$refs.planta.clientWidth;
      this.clientHeight = this.$refs.planta.clientHeight;
    },
    select: function select(area) {
      if (this.selected) {
        this.selected.classList.remove('selected');
      }
      this.selected = area;
      this.selected.classList.add('selected');
    },
    deselect: function deselect() {
      if (this.selected) {
        this.selected.classList.toggle('selected');
        this.selected = null;
      }
    },
    setInteractive: function setInteractive() {
      var vm = this;
      this.$interact('.draggable').unset();
      this.$interact('.notdraggable').unset();
      vm.$interact('.notdraggable').on('doubletap', function (event) {
        var target = event.target;
        var key = target.getAttribute('data-key');
        var currentArea = vm.certificationProcess.areas[key];
        vm.$refs.add_area_dialog.edit(currentArea, key);
        event.preventDefault();
      }).on('tap', function (event) {
        if (!event.selectDone) {
          event.selectDone = true;
          vm.select(event.currentTarget);
        }
      });
      vm.$interact('.draggable').draggable({
        inertia: false,
        max: Infinity,
        restrict: {
          restriction: 'parent',
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        autoScroll: false,
        onstart: function onstart(event) {
          console.log('on start event');
          vm.select(event.currentTarget);
        },
        onmove: vm.dragMoveListener,
        onend: vm.endMoveListener
      }).resizable({
        preserveAspectRatio: false,
        invert: 'reposition',
        edges: {
          left: '[resize-edges~=left]',
          right: '[resize-edges~=right]',
          bottom: '[resize-edges~=bottom]',
          top: '[resize-edges~=top]'
        },
        onmove: vm.resizeMoveListener,
        onend: vm.resizeEndListener
      }).on('doubletap', function (event) {
        var target = event.target;
        var key = target.getAttribute('data-key');
        var currentArea = vm.certificationProcess.areas[key];
        vm.$refs.add_area_dialog.edit(currentArea, key);
        event.preventDefault();
      }).on('tap', function (event) {
        if (!event.selectDone) {
          event.selectDone = true;
          vm.select(event.currentTarget);
        }
      });
    },
    addArea: function addArea() {
      this.$refs.add_area_dialog.open();
    },
    loadBlueprint: function loadBlueprint(imageBlob) {
      var vm = this;
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        vm.blueprint = e.target.result;
        var img = new Image();
        img.src = vm.blueprint;
        img.onload = function () {
          var ratio = Math.min(window.innerWidth / img.width, window.innerHeight / img.height);
          vm.bpWidth = Math.round(img.width * ratio);
          vm.bpHeight = Math.round(img.height * ratio);
          vm.$set(vm.certificationProcess, 'bpWidth', vm.bpWidth);
          vm.$set(vm.certificationProcess, 'bpHeight', vm.bpHeight);
          vm.$set(vm.certificationProcess, 'deviceWidth', window.innerWidth);
          vm.$set(vm.certificationProcess, 'deviceHeight', window.innerHeight);
          vm.SET_PROCESS(vm.certificationProcess);
          vm.setInteractive();
        };
      };
      fileReader.readAsDataURL(imageBlob);
    },
    resizeMoveListener: function resizeMoveListener(event) {
      var target = event.target;
      var x = parseFloat(target.getAttribute('data-x')) || 0;
      var y = parseFloat(target.getAttribute('data-y')) || 0;

      // update the element's style
      target.style.width = event.rect.width + 'px';
      target.style.height = event.rect.height + 'px';

      // translate when resizing from top or left edges
      x += event.deltaRect.left;
      y += event.deltaRect.top;

      target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';

      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    },
    dragMoveListener: function dragMoveListener(event) {
      var target = event.target;
      // keep the dragged position in the data-x/data-y attributes
      var x = parseFloat(target.getAttribute('data-x')) || 0;
      x += event.dx;
      var y = parseFloat(target.getAttribute('data-y')) || 0;
      y += event.dy;
      // translate the element
      target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

      // update the posiion attributes
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    },
    resizeEndListener: function resizeEndListener(event) {
      var target = event.target;
      var key = target.getAttribute('data-key');
      var w = event.rect.width;
      var wScaled = w / (this.clientWidth / this.certificationProcess.bpWidth);
      var h = event.rect.height;
      var hScaled = h / (this.clientHeight / this.certificationProcess.bpHeight);

      var x = parseFloat(target.getAttribute('data-x')) || 0;
      var xScaled = x / (this.clientWidth / this.certificationProcess.bpWidth);
      var y = parseFloat(target.getAttribute('data-y')) || 0;
      var yScaled = y / (this.clientHeight / this.certificationProcess.bpHeight);
      var currentArea = this.certificationProcess.areas[key];

      currentArea.vertices = this.calculateVertices(xScaled, yScaled, wScaled, hScaled); // ????

      currentArea.w = wScaled;
      currentArea.h = hScaled;
      currentArea.x = xScaled;
      currentArea.y = yScaled;

      this.SET_AREA({ area: currentArea, key: key });
    },
    endMoveListener: function endMoveListener(event) {
      var target = event.target;
      var key = target.getAttribute('data-key');
      var x = parseFloat(target.getAttribute('data-x')) || 1;
      var xScaled = x / (this.clientWidth / this.certificationProcess.bpWidth);
      var y = parseFloat(target.getAttribute('data-y')) || 1;
      var yScaled = y / (this.clientHeight / this.certificationProcess.bpHeight);

      var currentArea = this.certificationProcess.areas[key];

      currentArea.vertices = this.calculateVertices(xScaled, yScaled, currentArea.w, currentArea.h); // ????

      currentArea.x = xScaled;
      currentArea.y = yScaled;

      this.SET_AREA({ area: currentArea, key: key });
    },
    calculateVertices: function calculateVertices(areaX, areaY, areaW, areaH) {
      var vertices = [];
      var margem = 11;
      // top left
      var v0 = {
        id: 0,
        x: areaX,
        y: areaY,
        photos: [{ name: 'Chão', description: 'Fique em frente ao vértice e aponte para o chão', image: '' }, { name: 'Teto', description: 'Fique em frente ao vértice e aponte para o teto', image: '' }, { name: 'Vértice Oposto', description: 'Aponte para o vertice oposto', image: '' }],
        type: 'vertice',
        name: 'Vértice Superior Esquerdo'
        // top right
      };var v1 = {
        id: 1,
        x: parseInt(areaW, 10) + areaX - margem,
        y: areaY,
        photos: [{ name: 'Chão', description: 'Fique em frente ao vértice e aponte para o chão', image: '' }, { name: 'Teto', description: 'Fique em frente ao vértice e aponte para o teto', image: '' }, { name: 'Vértice Oposto', description: 'Aponte para o vertice oposto', image: '' }],
        type: 'vertice',
        name: 'Vértice Superior Direito'
        // bottom right
      };var v2 = {
        id: 2,
        x: parseInt(areaW, 10) + areaX - margem,
        y: parseInt(areaH, 10) + areaY - margem,
        photos: [{ name: 'Chão', description: 'Fique em frente ao vértice e aponte para o chão', image: '' }, { name: 'Teto', description: 'Fique em frente ao vértice e aponte para o teto', image: '' }, { name: 'Vértice Oposto', description: 'Aponte para o vertice oposto', image: '' }],
        type: 'vertice',
        name: 'Vértice Inferior Direito'
        // bottom left
      };var v3 = {
        id: 3,
        x: areaX,
        y: parseInt(areaH, 10) + areaY - margem,
        photos: [{ name: 'Chão', description: 'Fique em frente ao vértice e aponte para o chão', image: '' }, { name: 'Teto', description: 'Fique em frente ao vértice e aponte para o teto', image: '' }, { name: 'Vértice Oposto', description: 'Aponte para o vertice oposto', image: '' }],
        type: 'vertice',
        name: 'Vértice Inferior Esquerdo'
      };
      vertices.push(v0);
      vertices.push(v1);
      vertices.push(v2);
      vertices.push(v3);
      return vertices;
    }
  })
});

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CameraImageSelect__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CameraImageSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CameraImageSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'camera',
  components: {
    CameraImageSelect: __WEBPACK_IMPORTED_MODULE_2__components_CameraImageSelect___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    certificationProcess: function certificationProcess(state) {
      return state.certificationProcess;
    }
  })),
  data: function data() {
    return {
      previewSrc: '',
      activeImgId: null,
      activePhotoKey: 0,
      imgW: 0,
      imgH: 0,
      activeArea: 0,
      activeType: '',
      activeStructureKey: 0,
      activeItem: {},
      continueButton: 'PRÓXIMO',
      isFinished: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.activeArea = this.$route.params.area;
    this.activeType = this.$route.params.type;
    this.activeStructureKey = this.$route.params.structureKey;
    this.FETCH_DATA().then(function () {
      _this.loadItem();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['FETCH_DATA', 'FETCH_IMAGE', 'SET_PHOTO']), {
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
      this.isFinished = false;
    },
    closeDialog: function closeDialog(ref) {
      this.isFinished = false;
      this.$refs[ref].close();
    },
    loadItem: function loadItem() {
      if (this.activeType === 'vertice') {
        this.activeItem = this.certificationProcess.areas[this.activeArea].vertices[this.activeStructureKey];
      } else {
        this.activeItem = this.certificationProcess.areas[this.activeArea].structures[this.activeStructureKey];
      }
      if (this.activeItem.photos[0].image) {
        this.activeImgId = this.activeItem.photos[0].image;
        this.activePhotoKey = 0;
        // this.loadImage()
      }
    },
    removePhoto: function removePhoto() {
      this.$refs.cameraImageSelect[this.activePhotoKey].remove();
      this.previewSrc = '';
      this.activePhotoKey = 0;
    },
    revokeURL: function revokeURL() {
      URL.revokeObjectURL(this.previewSrc);
    },
    loadImage: function loadImage() {
      console.log('loading image');
      var vm = this;
      this.FETCH_IMAGE(this.activeImgId).then(function (imageBlob) {
        URL.revokeObjectURL(vm.previewSrc);
        vm.previewSrc = URL.createObjectURL(imageBlob);
      }).catch(function () {
        console.log('imagem não existe localmente');
        console.log(vm.activeItem.photos[vm.activePhotoKey].url);
        vm.previewSrc = vm.activeItem.photos[vm.activePhotoKey].url;
      });
    },
    addPhoto: function addPhoto(imgId, photoKey, preview) {
      var vm = this;
      vm.activeImgId = imgId;
      vm.activePhotoKey = photoKey;
      this.SET_PHOTO({
        areaKey: this.activeArea,
        type: this.activeType,
        structureKey: this.activeStructureKey,
        photoKey: this.activePhotoKey,
        image: this.activeImgId
      }).then(function () {
        vm.previewSrc = preview;
        vm.checkFinished();
      });
    },
    checkFinished: function checkFinished() {
      var hasFinished = true;
      this.activeItem.photos.forEach(function (photo) {
        if (!photo.image) {
          hasFinished = false;
        }
      });

      this.isFinished = hasFinished;

      if (hasFinished) {
        this.continueButton = 'FINALIZAR';
      }
    },
    onCompleted: function onCompleted() {
      if (this.isFinished) {
        this.$router.go(-1);
      }
    },
    previewImage: function previewImage(imageId, photoKey) {
      console.log('previewImage');
      this.activeImgId = imageId;
      this.activePhotoKey = photoKey;
      this.loadImage();
    }
  })
});

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AreaDefinitions__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AreaDefinitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AreaDefinitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PhotosList__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PhotosList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PhotosList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_SyncQueue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_SyncQueue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_SyncQueue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CheckRequisites__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CheckRequisites___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_CheckRequisites__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    AreaDefinitions: __WEBPACK_IMPORTED_MODULE_2__components_AreaDefinitions___default.a,
    PhotosList: __WEBPACK_IMPORTED_MODULE_3__components_PhotosList___default.a,
    SyncQueue: __WEBPACK_IMPORTED_MODULE_4__views_SyncQueue___default.a,
    CheckRequisites: __WEBPACK_IMPORTED_MODULE_5__components_CheckRequisites___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    uid: function uid(state) {
      return state.uid;
    },
    blh: function blh(state) {
      return state.blh;
    },
    step: function step(state) {
      return state.step;
    },
    certificationProcess: function certificationProcess(state) {
      return state.certificationProcess;
    },
    isAreaActive: function isAreaActive(state) {
      return state.step === 0;
    },
    isPhotoActive: function isPhotoActive(state) {
      return state.step === 1;
    },
    isReviewActive: function isReviewActive(state) {
      return state.step === 2;
    },
    isSubmitActive: function isSubmitActive(state) {
      return state.step === 3;
    }
  })),
  data: function data() {
    return {
      index: 0,
      hasLoaded: false,
      userBlhs: [],
      selectedBLH: null,
      meetRequisites: false
    };
  },
  beforeMount: function beforeMount() {
    var vm = this;
    // Fetch user blhs and check if it has more than one, let him choose wich blh he wants to manage
    vm.FETCH_USER_BLHS().then(function (blhs) {
      if (!blhs) {
        // user has no blh access
      } else {
        if (blhs.length > 1) {
          // user has more than one blh access
          vm.userBlhs = blhs;
          vm.hasLoaded = true;
        } else {
          vm.userBlhs = blhs;
          vm.SET_BLH({ blh: vm.userBlhs[0] }).then(function () {
            vm.FETCH_DATA().then(function () {
              vm.hasLoaded = true;
            });
          });
        }
      }
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['FETCH_DATA', 'GOTO_STEP', 'SET_PROCESS', 'CREATE_PROCESS', 'FETCH_USER_BLHS', 'SET_BLH']), {
    setActiveBLH: function setActiveBLH() {
      var vm = this;
      this.SET_BLH({ blh: this.userBlhs[this.selectedBLH] }).then(function () {
        vm.FETCH_DATA().then(function () {
          vm.hasLoaded = true;
        });
      });
    },

    // checkQuota () {
    //   let vm = this
    //   navigator.webkitTemporaryStorage.queryUsageAndQuota(
    //     function (usedBytes, grantedBytes) {
    //       console.log('we are using ', usedBytes, ' of ', grantedBytes, 'bytes')
    //       if (grantedBytes - usedBytes <= 4000000) {
    //         console.log('TAMANHO INSUFICIENTE PARA PROSSEGUIR COM O PROCESSO')
    //         vm.quotaExceeded = true
    //       } else {
    //         // vm.quotaExceeded = false
    //       }
    //     },
    //     function (e) {
    //       console.log('Error', e)
    //       vm.quotaExceeded = true
    //     }
    //   )
    // },
    changeHandler: function changeHandler(index) {
      if (index === this.index) {
        return;
      }
      this.index = index;
      if (!this.$refs.tabs) return;
      var tabs = this.$refs.tabs;
      if (!tabs.activeTab) return;
      if (!tabs.tabList.hasOwnProperty(tabs.activeTab)) return;
      var activeTab = tabs.tabList[tabs.activeTab].ref;
      if (!activeTab) return;
      switch (activeTab) {
        case this.$refs.tabAreas:
          this.GOTO_STEP(0);
          break;
        case this.$refs.tabFotos:
          this.GOTO_STEP(1);
          break;
        case this.$refs.tabReview:
          this.GOTO_STEP(2);
          break;
        case this.$refs.tabSyncronization:
          this.GOTO_STEP(3);
          break;
        default:
          console.error('unknown tab:', activeTab);
      }
    },
    startCertificationProcess: function startCertificationProcess() {
      this.CREATE_PROCESS();
    },
    syncTemp: function syncTemp() {
      this.$router.push('sync');
    },
    startSync: function startSync() {
      var _this = this;

      this.$set(this.certificationProcess, 'status', 6);
      this.SET_PROCESS(this.certificationProcess).then(function () {
        _this.GOTO_STEP(3);
      });
    },
    onRequisitesCheck: function onRequisitesCheck(_meetRequisites) {
      this.meetRequisites = _meetRequisites;
    }
    // checkRequisites () {
    //   if (!performance.memory) {
    //     // NO ACCESS TO PERFORMANCE CHECK
    //   } else {
    //     console.log(this.formatBytes(1000 * 1048576)) // 1GB
    //     console.log(this.formatBytes(performance.memory.jsHeapSizeLimit))
    //   }

    //   if (navigator.storage) {
    //     navigator.storage.estimate().then((storageResults) => {
    //       console.log('storage estimate:', this.formatBytes(storageResults.quota))
    //     })
    //   }

    //   if (navigator.userAgent) {
    //     console.log('chrome version:', navigator.userAgent)
    //   }
    // },
    // formatBytes (a, b) {
    //   if (a === 0) return '0 Bytes'
    //   var c = 1024
    //   var d = b || 2
    //   var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    //   var f = Math.floor(Math.log(a) / Math.log(c))
    //   return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
    // }

  })
});

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      credentials: {
        email: '',
        password: ''
      },
      erro: ''
    };
  },

  methods: {
    login: function login() {
      var vm = this;
      vm.$store.dispatch('LOGIN', vm.credentials).then(function (uid) {
        console.log('user authenticated');
        vm.$router.push('home');
      }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        switch (errorCode.toString()) {
          case 'auth/user-not-found':
            errorMessage = 'Usuário não encontrado';
            break;
          case 'auth/invalid-email':
            errorMessage = 'Email Inválido';
            break;
          case 'auth/wrong-password':
            errorMessage = 'Senha Inválida';
            break;
          case 'auth/network-request-failed':
            errorMessage = 'Ocorreu um erro de rede, verifique se você está conectado à internet';
            break;
          case '101':
            errorMessage = 'Usuário/Senha Inválidos';
        }

        vm.erro = errorMessage + ' (' + errorCode + ')';
        vm.$refs.snackbar.open();
      });
    }
  }
});

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StructureCameraIcon__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_StructureCameraIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_StructureCameraIcon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photos-view',
  components: {
    StructureCameraIcon: __WEBPACK_IMPORTED_MODULE_2__components_StructureCameraIcon___default.a
  },
  data: function data() {
    return {
      blueprint: '',
      bpHeight: 100,
      bpWidth: 100
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    certificationProcess: function certificationProcess(state) {
      return state.certificationProcess;
    },
    currPhotoType: function currPhotoType(state) {
      return state.currPhotoType;
    },
    currPhotoArea: function currPhotoArea(state) {
      return state.currPhotoArea;
    }
  }), {
    vertices: function vertices() {
      var vm = this;
      if (!this.certificationProcess.areas) {
        return [];
      } else {
        return this.certificationProcess.areas[vm.currPhotoArea].vertices;
      }
    },
    structures: function structures() {
      var vm = this;
      if (!this.certificationProcess.areas) {
        return [];
      } else {
        if (!this.certificationProcess.areas[vm.currPhotoArea].structures) {
          return [];
        }
        return this.certificationProcess.areas[vm.currPhotoArea].structures;
      }
    },
    isAreaFinished: function isAreaFinished() {
      var isFinished = true;
      for (var v = 0; v < this.certificationProcess.areas[this.currPhotoArea].vertices.length; v++) {
        var vertice = this.certificationProcess.areas[this.currPhotoArea].vertices[v];
        if (vertice.status == null || vertice.status === 0) isFinished = false;
      }

      if (this.certificationProcess.areas[this.currPhotoArea].structures) {
        for (var _v = 0; _v < this.certificationProcess.areas[this.currPhotoArea].structures.length; _v++) {
          var structure = this.certificationProcess.areas[this.currPhotoArea].structures[_v];
          if (structure.status == null || structure.status === 0) isFinished = false;
        }
      }

      return isFinished;
    }
  }),
  beforeMount: function beforeMount() {
    this.FETCH_DATA();
    // .then(() => {
    // this.bpHeight = this.certificationProcess.bpHeight
    // this.bpWidth = this.certificationProcess.bpWidth
    // this.FETCH_IMAGE(this.certificationProcess.blueprint).then(imageBlob => {
    //   this.loadBlueprint(imageBlob)
    // })
    // })
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['FETCH_DATA',
  // 'FETCH_IMAGE',
  'SET_AREA', 'SET_PHOTO_TYPE', 'SET_PHOTO_AREA']), {
    changeActiveType: function changeActiveType(type) {
      this.SET_PHOTO_TYPE(type);
    },
    addPhotos: function addPhotos(structureKey, type) {
      var vm = this;
      this.$router.push({
        name: 'Camera',
        params: {
          area: vm.currPhotoArea,
          structureKey: structureKey,
          type: type
        }
      });
    },
    loadBlueprint: function loadBlueprint(imageBlob) {
      var vm = this;
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        vm.blueprint = e.target.result;
      };
      fileReader.readAsDataURL(imageBlob);
    },
    isActiveArea: function isActiveArea(index) {
      return true;
    },
    onAreaChangeDelegate: function onAreaChangeDelegate(index) {
      var _this = this;

      if (index === this.currPhotoArea) {
        return;
      }

      this.SET_PHOTO_AREA(index).then(function () {
        // this.currentAreaKey = index
        var currentArea = _this.certificationProcess.areas[_this.currPhotoArea];
        // Sometimes the user creates an area and dont specify any equipment, so we need to create the vertices here
        if (!currentArea.vertices || currentArea.vertices.length === 0) {
          _this.$set(currentArea, 'vertices', []);
          var margem = 11;
          // top left
          var v0 = {
            id: 0,
            x: currentArea.x,
            y: currentArea.y,
            photos: [{
              name: 'Chão',
              description: 'Fique em frente ao vértice e aponte para o chão',
              image: ''
            }, {
              name: 'Teto',
              description: 'Fique em frente ao vértice e aponte para o teto',
              image: ''
            }, {
              name: 'Vértice Oposto',
              description: 'Aponte para o vertice oposto',
              image: ''
            }],
            type: 'vertice',
            name: 'Vértice Superior Esquerdo'
            // top right
          };var v1 = {
            id: 1,
            x: parseInt(currentArea.w, 10) + currentArea.x - margem,
            y: currentArea.y,
            photos: [{
              name: 'Chão',
              description: 'Fique em frente ao vértice e aponte para o chão',
              image: ''
            }, {
              name: 'Teto',
              description: 'Fique em frente ao vértice e aponte para o teto',
              image: ''
            }, {
              name: 'Vértice Oposto',
              description: 'Aponte para o vertice oposto',
              image: ''
            }],
            type: 'vertice',
            name: 'Vértice Superior Direito'
            // bottom right
          };var v2 = {
            id: 2,
            x: parseInt(currentArea.w, 10) + currentArea.x - margem,
            y: parseInt(currentArea.h, 10) + currentArea.y - margem,
            photos: [{
              name: 'Chão',
              description: 'Fique em frente ao vértice e aponte para o chão',
              image: ''
            }, {
              name: 'Teto',
              description: 'Fique em frente ao vértice e aponte para o teto',
              image: ''
            }, {
              name: 'Vértice Oposto',
              description: 'Aponte para o vertice oposto',
              image: ''
            }],
            type: 'vertice',
            name: 'Vértice Inferior Direito'
            // bottom left
          };var v3 = {
            id: 3,
            x: currentArea.x,
            y: parseInt(currentArea.h, 10) + currentArea.y - margem,
            photos: [{
              name: 'Chão',
              description: 'Fique em frente ao vértice e aponte para o chão',
              image: ''
            }, {
              name: 'Teto',
              description: 'Fique em frente ao vértice e aponte para o teto',
              image: ''
            }, {
              name: 'Vértice Oposto',
              description: 'Aponte para o vertice oposto',
              image: ''
            }],
            type: 'vertice',
            name: 'Vértice Inferior Esquerdo'
          };

          currentArea.vertices.push(v0);
          currentArea.vertices.push(v1);
          currentArea.vertices.push(v2);
          currentArea.vertices.push(v3);

          _this.SET_AREA({ area: currentArea, key: _this.currPhotoArea });
        }
      });
    },
    nextArea: function nextArea(currentIndex) {
      this.SET_PHOTO_AREA(currentIndex + 1);
    },
    prevArea: function prevArea(currentIndex) {
      this.SET_PHOTO_AREA(currentIndex - 1);
    }
  })
});

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DraggableStructure__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DraggableStructure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DraggableStructure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AddStructureDialog__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AddStructureDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AddStructureDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'structure',
  components: {
    DraggableStructure: __WEBPACK_IMPORTED_MODULE_2__components_DraggableStructure___default.a,
    AddStructureDialog: __WEBPACK_IMPORTED_MODULE_3__components_AddStructureDialog___default.a
  },
  data: function data() {
    return {
      currentAreaKey: 0,
      blueprint: '',
      bpHeight: 100,
      bpWidth: 100,
      wHeight: 100,
      wWidth: 100,
      activeIndex: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    certificationProcess: function certificationProcess(state) {
      return state.certificationProcess;
    }
  })),
  // beforeDestroy() {
  //   this.$interact('.draggable-structure').unset()
  // },
  created: function created() {
    this.wHeight = window.innerHeight - 155;
    this.wWidth = window.innerWidth;
    this.FETCH_DATA().then(function () {
      // this.bpHeight = this.certificationProcess.bpHeight
      // this.bpWidth = this.certificationProcess.bpWidth
      // this.FETCH_IMAGE(this.certificationProcess.blueprint).then(imageBlob => {
      //   this.loadBlueprint(imageBlob)
      // })
    });
    // window.dragMoveListener = this.dragMoveListener
  },
  mounted: function mounted() {
    // this.setInteractive()
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['FETCH_DATA', 'SET_PROCESS', 'FETCH_IMAGE', 'SET_AREA']), {
    // loadBlueprint(imageBlob) {
    //   var vm = this
    //   let fileReader = new FileReader()
    //   fileReader.onload = function(e) {
    //     vm.blueprint = e.target.result
    //     var img = new Image()
    //     img.src = vm.blueprint
    //     img.onload = () => {
    //       // let ratio = Math.min((window.innerWidth - 16) / img.width,(window.innerHeight - 48) / img.height)
    //       // vm.bpWidth = Math.round(img.width * ratio)
    //       // vm.bpHeight = Math.round(img.height * ratio)
    //       vm.blueprint = vm.blueprint
    //     }
    //   }
    //   fileReader.readAsDataURL(imageBlob)
    // },
    onAreaChangeDelegate: function onAreaChangeDelegate(index) {
      this.currentAreaKey = index;
      this.activeIndex = index;
      // this.activeIndex = index
      var currentArea = this.certificationProcess.areas[this.currentAreaKey];
      if (!currentArea.vertices || currentArea.vertices.length === 0) {
        this.$set(currentArea, 'vertices', []);
        var margem = 11;
        // top left
        var v0 = {
          id: 0,
          x: currentArea.x,
          y: currentArea.y,
          photos: [{
            name: 'Chão',
            description: 'Fique em frente ao vértice e aponte para o chão',
            image: ''
          }, {
            name: 'Teto',
            description: 'Fique em frente ao vértice e aponte para o teto',
            image: ''
          }, {
            name: 'Vértice Oposto',
            description: 'Aponte para o vertice oposto',
            image: ''
          }],
          type: 'vertice',
          name: 'Vértice Superior Esquerdo'
          // top right
        };var v1 = {
          id: 1,
          x: parseInt(currentArea.w, 10) + currentArea.x - margem,
          y: currentArea.y,
          photos: [{
            name: 'Chão',
            description: 'Fique em frente ao vértice e aponte para o chão',
            image: ''
          }, {
            name: 'Teto',
            description: 'Fique em frente ao vértice e aponte para o teto',
            image: ''
          }, {
            name: 'Vértice Oposto',
            description: 'Aponte para o vertice oposto',
            image: ''
          }],
          type: 'vertice',
          name: 'Vértice Superior Direito'
          // bottom right
        };var v2 = {
          id: 2,
          x: parseInt(currentArea.w, 10) + currentArea.x - margem,
          y: parseInt(currentArea.h, 10) + currentArea.y - margem,
          photos: [{
            name: 'Chão',
            description: 'Fique em frente ao vértice e aponte para o chão',
            image: ''
          }, {
            name: 'Teto',
            description: 'Fique em frente ao vértice e aponte para o teto',
            image: ''
          }, {
            name: 'Vértice Oposto',
            description: 'Aponte para o vertice oposto',
            image: ''
          }],
          type: 'vertice',
          name: 'Vértice Inferior Direito'
          // bottom left
        };var v3 = {
          id: 3,
          x: currentArea.x,
          y: parseInt(currentArea.h, 10) + currentArea.y - margem,
          photos: [{
            name: 'Chão',
            description: 'Fique em frente ao vértice e aponte para o chão',
            image: ''
          }, {
            name: 'Teto',
            description: 'Fique em frente ao vértice e aponte para o teto',
            image: ''
          }, {
            name: 'Vértice Oposto',
            description: 'Aponte para o vertice oposto',
            image: ''
          }],
          type: 'vertice',
          name: 'Vértice Inferior Esquerdo'
        };

        currentArea.vertices.push(v0);
        currentArea.vertices.push(v1);
        currentArea.vertices.push(v2);
        currentArea.vertices.push(v3);

        this.SET_AREA({ area: currentArea, key: this.currentAreaKey });
      }
    },
    addStructure: function addStructure() {
      var vm = this;
      vm.$refs.add_structure_dialog.openDialog(vm.currentAreaKey, null, null);
    },
    setInteractive: function setInteractive() {
      var _this = this;

      console.log('set interactive');
      var vm = this;
      vm.$interact('.draggable-structure').unset();
      vm.$interact('.draggable-structure').draggable({
        inertia: false,
        max: Infinity,
        restrict: {
          restriction: 'parent',
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        autoScroll: false
      }).on('dragmove', function (event) {
        var target = event.target;
        // keep the dragged position in the data-x/data-y attributes
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

        // translate the element
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

        // update the posiion attributes
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
      }).on('dragend', function (event) {
        var target = event.target;
        var key = target.getAttribute('data-key');
        var x = parseFloat(target.getAttribute('data-x')) || 0;
        var y = parseFloat(target.getAttribute('data-y')) || 0;
        var item = _this.certificationProcess.areas[_this.currentAreaKey].structures[key];
        item.x = x;
        item.y = y;
        _this.certificationProcess.areas[_this.currentAreaKey].structures[key] = item;
        _this.SET_PROCESS(_this.certificationProcess);
      }).on('doubletap', function (event) {
        var target = event.target;
        var key = target.getAttribute('data-key');
        var currentItem = _this.certificationProcess.areas[_this.currentAreaKey].structures[key];
        _this.$refs.add_structure_dialog.openDialog(_this.currentAreaKey, currentItem, key);
        event.preventDefault();
      });
    },
    dragMoveListener: function dragMoveListener(event) {
      console.log('drag move listener');
      var target = event.target;
      // keep the dragged position in the data-x/data-y attributes
      var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
      var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

      // translate the element
      target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

      // update the posiion attributes
      target.setAttribute('data-x', x);
      target.setAttribute('data-y', y);
    },
    onEditStructure: function onEditStructure(key) {
      var currentItem = this.certificationProcess.areas[this.currentAreaKey].structures[key];
      this.$refs.add_structure_dialog.openDialog(this.currentAreaKey, currentItem, key);
      // event.preventDefault()
    },
    nextArea: function nextArea(currentIndex) {
      this.activeIndex = currentIndex + 1;
    },
    prevArea: function prevArea(currentIndex) {
      this.activeIndex = currentIndex - 1;
    }
  })
});

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_p_queue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_p_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_p_queue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var logRequests = true; // process.env.DEBUG_MODE

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sync-area-photos',
  data: function data() {
    return {
      queueStatus: 'creating',
      queueLog: '',
      currentArea: '',
      currentItem: '',
      currentPhoto: '',
      progress: 0,
      totalItems: 0,
      faultyPhotos: [],
      networkStatus: true,
      finishedWithoutErrors: true,
      queue: { type: __WEBPACK_IMPORTED_MODULE_4_p_queue___default.a }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    certificationProcess: function certificationProcess(state) {
      return state.certificationProcess;
    },
    activeArea: function activeArea(state) {
      return state.currPhotoArea;
    },
    blh: function blh(state) {
      return state.blh;
    },
    uid: function uid(state) {
      return state.uid;
    }
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    window.addEventListener('online', this.handleConnectivityChange);
    window.addEventListener('offline', this.handleConnectivityChange);
    this.networkStatus = navigator.onLine;
    this.FETCH_DATA().then(function () {
      _this.$nextTick(function () {
        if (_this.certificationProcess.areas[_this.activeArea].status <= 1) {
          _this.createQueue();
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('online', this.handleConnectivityChange);
    window.removeEventListener('offline', this.handleConnectivityChange);
    console.log(this.queue);
    if (this.queue.constructor === __WEBPACK_IMPORTED_MODULE_4_p_queue___default.a) {
      this.queue.pause();
      this.queue.clear();
    }
  },
  updated: function updated() {
    if (!this.networkStatus) {
      this.$refs.snackbar.open();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['FETCH_DATA', 'FETCH_IMAGE', 'UPLOAD_FILE', 'PHOTO_SYNC', 'SET_AREA']), {
    startQueue: function startQueue() {
      logRequests && console.log('[Queue Started]');
      // clear the faulty photos
      this.faultyPhotos = [];
      this.queueStatus = 'running';
      this.queue.start();
    },
    createQueue: function createQueue() {
      var _this2 = this;

      this.queueStatus = 'creating';
      this.queue = new __WEBPACK_IMPORTED_MODULE_4_p_queue___default.a({ concurrency: 1, autoStart: false });
      logRequests && console.log('Creating Queue...');
      var count = 0;

      this.queue.on('active', function () {
        _this2.queueLog = 'Trablhando no item #' + ++count + '. Total: ' + _this2.queue.size + ' Pendente: ' + _this2.queue.pending;
        _this2.progress = parseInt(count / _this2.totalItems * 100, 10);
        logRequests && console.log(_this2.queueLog);
      });

      this.queue.on('error', function (error) {
        _this2.finishedWithoutErrors = false;
        console.log(error);
      });

      var area = this.certificationProcess.areas[this.activeArea];

      this.queueLog = 'Carregando Area ' + area.name;

      this.queueAreaStructureUpload(area, this.activeArea);

      this.queueAreaVerticeUpload(area, this.activeArea);

      this.queueLog = 'Areas carregadas com sucesso...';
      this.totalItems = this.queue.size;
      this.queueStatus = 'waiting';

      this.queue.onIdle().then(function () {
        // TODO: check if errors before updating the area status...
        console.log(_this2.faultyPhotos);
        if (_this2.finishedWithoutErrors && _this2.faultyPhotos.length <= 0) {
          console.log('Area finished without errors or faultyphotos');
          area.status = 2;
          _this2.SET_AREA({ area: area, key: _this2.activeArea });
        }
      });

      logRequests && console.log('[Queue created with ' + this.queue.size + ' items pending]');
    },
    queueAreaStructureUpload: function queueAreaStructureUpload(area, areaIndex) {
      var vm = this;
      if (!area.structures) {
        logRequests && console.warn('Area without structures ' + area.name);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(); // This is normal, we dont throw an error here.
      }

      for (var structureIndex = 0; structureIndex < area.structures.length; structureIndex++) {
        var structure = area.structures[structureIndex];
        if (!structure || !structure.photos) {
          logRequests && console.warn('Structures structureIndex:' + structureIndex + ' null or dont have photos');
          continue; // This is not supposed to happen...
        }
        vm.queuePhotoUpload(structure, area, structureIndex, areaIndex);
      }
    },
    queueAreaVerticeUpload: function queueAreaVerticeUpload(area, areaIndex) {
      var vm = this;
      if (!area.vertices) {
        logRequests && console.warn('Area without vertices ' + area.name);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(); // This is not supposed to happen...
      }
      for (var verticeIndex = 0; verticeIndex < area.vertices.length; verticeIndex++) {
        var vertice = area.vertices[verticeIndex];
        if (!vertice || !vertice.photos) {
          logRequests && console.warn('Vertice verticeIndex:' + verticeIndex + ' null or dont have photos');
          continue;
        }
        vm.queuePhotoUpload(vertice, area, verticeIndex, areaIndex);
      }
    },
    queuePhotoUpload: function queuePhotoUpload(item, area, itemIndex, areaIndex) {
      var vm = this;
      logRequests && console.log('Queueing ' + item.photos.length + ' photos for ' + area.name + '-' + item.name);

      if (!item.photos) {
        // Checking for nulls again just to be sure
        logRequests && console.warn('Item without photos: ' + item.name + '-' + area.name);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }

      var _loop = function _loop(photoIndex) {
        var photo = item.photos[photoIndex];
        if (!photo) {
          logRequests && console.warn('Photos is empty: [' + photoIndex + '] ' + item.name + '-' + area.name);
          return {
            v: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Photos is empty: [' + photoIndex + '] ' + item.name + '-' + area.name)
          };
        }
        // If photo has not been synced yet
        if (photo.status !== 2) {
          vm.queue.add(function () {
            return vm.upload(photo, area, item, photoIndex, itemIndex, areaIndex);
          });
        }
      };

      for (var photoIndex = 0; photoIndex < item.photos.length; photoIndex++) {
        var _ret = _loop(photoIndex);

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      }
    },
    upload: function upload(photo, area, item, photoIndex, itemIndex, areaIndex) {
      var _this3 = this;

      var vm = this;

      if (!photo) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Item ' + item.name + ' photo is null');
      }

      if (!photo.image) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Item ' + item.name + ' photo ' + photo.name + ' image is null');
      }

      return this.FETCH_IMAGE(photo.image).then(function (imgBlob) {
        if (!imgBlob) {
          logRequests && console.warn('Image not found, may be corrupted, need to re-take it');
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Image not found, may be corrupted, need to re-take it');
        }

        vm.currentArea = area.name;
        vm.currentItem = item.name;
        vm.currentPhoto = photo.name;

        var fileName = vm.blh.currentYear + '_' + vm.uid + '_' + photo.image + '.png';
        var file = new File([imgBlob], fileName);
        logRequests && console.log('Uploading file: ' + fileName + '.jpg with size: ' + file.size);
        return vm.UPLOAD_FILE({ image: file, name: fileName }).then(function (fileUrl) {
          logRequests && console.log('File uploaded: ' + fileName + '.jpg with size: ' + file.size);
          return vm.PHOTO_SYNC({
            photoId: photoIndex,
            areaId: areaIndex,
            itemId: itemIndex,
            type: item.type,
            status: 2,
            image: photo.image,
            url: fileUrl
          });
        }).catch(function (error) {
          console.log('Error uploading ' + error);
          _this3.faultyPhotos.push(photo);
        });
      });
    },
    handleConnectivityChange: function handleConnectivityChange() {
      this.networkStatus = navigator.onLine;
      logRequests && console.log('handleConnectiveChange:' + this.networkStatus);
      if (this.networkStatus) {
        this.$refs.snackbar.close();
      } else {
        this.queue.pause();
        this.queueStatus = 'waiting';
        this.$refs.snackbar.open();
      }
    }
  })
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_p_queue__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_p_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_p_queue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var logRequests = true; // process.env.DEBUG_MODE
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sync-queue',
  data: function data() {
    return {
      queueStatus: 'creating',
      queueLog: '',
      currentArea: '',
      currentItem: '',
      currentPhoto: '',
      progress: 0,
      totalItems: 0,
      faultyPhotos: [],
      blueprintError: '',
      queue: { type: __WEBPACK_IMPORTED_MODULE_4_p_queue___default.a },
      finishedWithoutErrors: true,
      networkStatus: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    certificationProcess: function certificationProcess(state) {
      return state.certificationProcess;
    },
    blh: function blh(state) {
      return state.blh;
    },
    uid: function uid(state) {
      return state.uid;
    }
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    window.addEventListener('online', function () {
      _this.handleConnectivityChange();
    });
    window.addEventListener('offline', function () {
      _this.handleConnectivityChange();
    });
    this.networkStatus = navigator.onLine;
    this.FETCH_DATA().then(function () {
      _this.$nextTick(function () {
        if (_this.certificationProcess.status <= 6) {
          _this.createQueue();
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('online', this.handleConnectivityChange);
    window.removeEventListener('offline', this.handleConnectivityChange);
    if (this.queue.constructor === __WEBPACK_IMPORTED_MODULE_4_p_queue___default.a) {
      this.queue.pause();
      this.queue.clear();
    }
  },
  updated: function updated() {
    if (!this.networkStatus) {
      this.$refs.snackbar.open();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['FETCH_DATA', 'FETCH_IMAGE', 'UPLOAD_FILE', 'PHOTO_SYNC', 'SYNC_PROCESS', 'SET_PROCESS', 'GOTO_STEP']), {
    restartQueue: function restartQueue() {
      logRequests && console.log('[Queue Restarted]');
      if (this.queue.constructor === __WEBPACK_IMPORTED_MODULE_4_p_queue___default.a) {
        this.queue.pause();
        this.queue.clear();
      }
      this.createQueue();
      this.queueStatus = 'waiting';
    },
    startQueue: function startQueue() {
      logRequests && console.log('[Queue Started]');
      this.queueStatus = 'running';
      this.queue.start();
    },
    createQueue: function createQueue() {
      var _this2 = this;

      this.faultyPhotos = [];
      this.queueStatus = 'creating';
      this.queue = new __WEBPACK_IMPORTED_MODULE_4_p_queue___default.a({ concurrency: 4, autoStart: false });
      logRequests && console.log('Creating Queue...');
      var count = 0;

      this.queue.on('active', function () {
        _this2.queueLog = 'Trablhando no item #' + ++count + '. Total: ' + _this2.queue.size + ' Pendente: ' + _this2.queue.pending;
        _this2.progress = parseInt(count / _this2.totalItems * 100, 10);
        logRequests && console.log(_this2.queueLog);
      });

      this.queue.on('error', function (error) {
        _this2.queueStatus = 'error';
        _this2.queueLog = 'Envio finalizado com erros.';
        _this2.finishedWithoutErrors = false;
        console.log(error);
      });

      this.queueAreas();
      this.queue.onIdle().then(function () {
        // console.log(this.faultyPhotos)
        _this2.queueLog = 'Enviando dados da planta.';
        _this2.uploadBluePrint().then(function (fileUrl) {
          if (_this2.finishedWithoutErrors && _this2.faultyPhotos.length <= 0) {
            _this2.SYNC_PROCESS(fileUrl).then(function () {
              _this2.queueLog = 'Envio finalizado.';
              _this2.queueStatus = 'complete';
            });
          } else {
            _this2.queueStatus = 'error';
            _this2.queueLog = 'Envio finalizado com erros.';
          }
        }).catch(function (error) {
          _this2.blueprintError = error;
          _this2.queueStatus = 'error';
          _this2.queueLog = 'Envio finalizado com erros.';
        });
      });

      logRequests && console.log('[Queue created with ' + this.queue.size + ' items pending]');
    },
    queueAreas: function queueAreas() {
      var vm = this;
      logRequests && console.log('Queuing areas ' + vm.certificationProcess.areas.length);

      for (var areaIndex = 0; areaIndex < vm.certificationProcess.areas.length; areaIndex++) {
        var area = vm.certificationProcess.areas[areaIndex];
        if (area.status !== 2) {
          vm.queueLog = 'Carregando Area A' + (areaIndex + 1) + ' ' + area.name;

          vm.queueAreaStructureUpload(area, areaIndex);
          vm.queueAreaVerticeUpload(area, areaIndex);
        }
      }

      this.queueLog = 'Areas carregadas com sucesso...';
      this.totalItems = this.queue.size;
      this.queueStatus = 'waiting';
    },
    queueAreaStructureUpload: function queueAreaStructureUpload(area, areaIndex) {
      var vm = this;
      if (!area.structures) {
        logRequests && console.warn('Area without structures ' + area.name);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(); // This is normal, we dont throw an error here.
      }

      for (var structureIndex = 0; structureIndex < area.structures.length; structureIndex++) {
        var structure = area.structures[structureIndex];
        if (!structure || !structure.photos) {
          logRequests && console.warn('Structures structureIndex:' + structureIndex + ' null or dont have photos');
          continue; // This is not supposed to happen...
        }
        vm.queuePhotoUpload(structure, area, structureIndex, areaIndex);
      }
    },
    queueAreaVerticeUpload: function queueAreaVerticeUpload(area, areaIndex) {
      var vm = this;
      if (!area.vertices) {
        logRequests && console.warn('Area without vertices ' + area.name);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(); // This is not supposed to happen...
      }
      for (var verticeIndex = 0; verticeIndex < area.vertices.length; verticeIndex++) {
        var vertice = area.vertices[verticeIndex];
        if (!vertice || !vertice.photos) {
          logRequests && console.warn('Vertice verticeIndex:' + verticeIndex + ' null or dont have photos');
          continue;
        }
        vm.queuePhotoUpload(vertice, area, verticeIndex, areaIndex);
      }
    },

    // queueBlueprintUpload () {

    // },
    // queueAlvaraUpload () {
    //   return Promise.resolve()
    // },
    queueCertificationSync: function queueCertificationSync() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
    },
    queuePhotoUpload: function queuePhotoUpload(item, area, itemIndex, areaIndex) {
      var vm = this;
      logRequests && console.log('Queueing ' + item.photos.length + ' photos for ' + area.name + '-' + item.name);

      if (!item.photos) {
        // Checking for nulls again just to be sure
        logRequests && console.warn('Item without photos: ' + item.name + '-' + area.name);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
      }

      var _loop = function _loop(photoIndex) {
        var photo = item.photos[photoIndex];
        if (!photo) {
          logRequests && console.warn('Photos is empty: [' + photoIndex + '] ' + item.name + '-' + area.name);
          return {
            v: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Photos is empty: [' + photoIndex + '] ' + item.name + '-' + area.name)
          };
        }
        // If photo has not been synced yet
        if (photo.status !== 2) {
          vm.queue.add(function () {
            return vm.upload(photo, area, item, photoIndex, itemIndex, areaIndex);
          });
        }
      };

      for (var photoIndex = 0; photoIndex < item.photos.length; photoIndex++) {
        var _ret = _loop(photoIndex);

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      }
    },
    uploadBluePrint: function uploadBluePrint() {
      var _this3 = this;

      if (this.certificationProcess.blueprintUrl) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.certificationProcess.blueprintUrl);
        // return this.SYNC_PROCESS(this.certificationProcess.blueprintUrl)
      } else {
        return this.FETCH_IMAGE(this.certificationProcess.blueprint).then(function (imgBlob) {
          var fileName = _this3.blh.currentYear + '_' + _this3.blh.id + '_' + _this3.certificationProcess.blueprint + '.jpg';
          return _this3.UPLOAD_FILE({
            image: new File([imgBlob], fileName),
            name: fileName
          });
          // .then(fileUrl => {
          //   this.SYNC_PROCESS(fileUrl)
          // })
        }).catch(function (err) {
          _this3.finishedWithoutErrors = false;
          console.log(err);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
        });
      }
    },

    // uploadAlvara () {

    // },
    upload: function upload(photo, area, item, photoIndex, itemIndex, areaIndex) {
      var _this4 = this;

      var vm = this;

      if (!photo) {
        this.faultyPhotos.push({
          'area': area,
          'item': item,
          'photo': photo,
          'itemIndex': itemIndex,
          'areaIndex': areaIndex,
          'photoIndex': photoIndex,
          'error': 'O item ' + item.name + ' n\xE3o existe'
        });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Item ' + item.name + ' photo is null');
      }

      if (!photo.image) {
        this.faultyPhotos.push({
          'area': area,
          'item': item,
          'photo': photo,
          'itemIndex': itemIndex,
          'areaIndex': areaIndex,
          'photoIndex': photoIndex,
          'error': 'A foto do item ' + item.name + ' n\xE3o existe'
        });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject('Item ' + item.name + ' photo ' + photo.name + ' image is null');
      }

      return this.FETCH_IMAGE(photo.image).then(function (imgBlob) {
        var error = '';
        if (!imgBlob) {
          error = 'O objeto n\xE3o existe ou est\xE1 corrompida.';
          logRequests && console.warn(error);
          _this4.faultyPhotos.push({
            'area': area,
            'item': item,
            'itemIndex': itemIndex,
            'areaIndex': areaIndex,
            'photoIndex': photoIndex,
            'photo': photo,
            'error': error
          });
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
        }

        vm.currentArea = area.name;
        vm.currentItem = item.name;
        vm.currentPhoto = photo.name;

        var fileName = vm.blh.currentYear + '_' + vm.uid + '_' + photo.image + '.png';
        var file = new File([imgBlob], fileName);
        logRequests && console.log('Uploading file: ' + fileName + '.jpg with size: ' + file.size);
        return vm.UPLOAD_FILE({ image: file, name: fileName }).then(function (fileUrl) {
          logRequests && console.log('File uploaded: ' + fileName + '.jpg with size: ' + file.size);
          return vm.PHOTO_SYNC({
            photoId: photoIndex,
            areaId: areaIndex,
            itemId: itemIndex,
            type: item.type,
            status: 2,
            image: photo.image,
            url: fileUrl
          });
        });
      }).catch(function (error) {
        console.log('' + error);
        _this4.faultyPhotos.push({
          'area': area,
          'item': item,
          'itemIndex': itemIndex,
          'areaIndex': areaIndex,
          'photoIndex': photoIndex,
          'photo': photo,
          'error': error
        });
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    handleConnectivityChange: function handleConnectivityChange() {
      this.networkStatus = navigator.onLine;
      logRequests && console.log('handleConnectiveChange:' + this.networkStatus);
      if (this.networkStatus) {
        this.$refs.snackbar.close();
      } else {
        this.queue.pause();
        this.queueStatus = 'waiting';
        this.$refs.snackbar.open();
      }
    },
    captureNewPhoto: function captureNewPhoto(objectItem) {
      this.$router.push({
        name: 'Camera',
        params: {
          area: objectItem.areaIndex,
          structureKey: objectItem.itemIndex,
          type: objectItem.item.type
        }
      });
    },
    captureNewBlueprint: function captureNewBlueprint() {
      var _this5 = this;

      this.$set(this.certificationProcess, 'status', 5);
      this.SET_PROCESS(this.certificationProcess).then(function () {
        _this5.GOTO_STEP(0);
      });
    }
  })
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AreaSyncList__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AreaSyncList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AreaSyncList__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sync-process',
  components: {
    'area-sync-list': __WEBPACK_IMPORTED_MODULE_2__components_AreaSyncList___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    'certificationProcess': function certificationProcess(state) {
      return state.certificationProcess;
    },
    'blh': function blh(state) {
      return state.blh;
    }
  })),
  data: function data() {
    return {
      areaSynced: [],
      syncStarted: false
    };
  },

  watch: {
    areaSynced: function areaSynced(newList) {
      if (this.areaSynced.length === this.certificationProcess.areas.length) {
        this.FETCH_IMAGE(this.certificationProcess.blueprint).then(function (imgBlob) {
          // storage.child(`${this.blh.currentYear}/${this.blh.id}/${this.certificationProcess.blueprint}`).put(imgBlob).then(() => {
          //   this.SYNC_TEMP_PROCESS(this.certificationProcess)
          // })
        });
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.FETCH_DATA();
    window.addEventListener('online', function () {
      _this.handleConnectivityChange(true);
    });
    window.addEventListener('offline', function () {
      _this.handleConnectivityChange(false);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['FETCH_DATA', 'FETCH_IMAGE', 'SYNC_TEMP_PROCESS']), {
    handleAreaSync: function handleAreaSync(areaId) {
      if (!this.areaSynced.find(function (id) {
        return id === areaId;
      })) {
        this.areaSynced.push(areaId);
      }
    },
    handleConnectivityChange: function handleConnectivityChange(status) {
      console.log('handleConnectiveChange:' + status);
      if (status) {
        this.$refs.snackbar.close();
        this.startSync();
      } else {
        this.syncStarted = false;
        this.$refs.snackbar.open();
      }
    },
    startSync: function startSync() {
      this.syncStarted = true;
    }
  })
});

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","C:\\projects\\blh\\blh-certification-process"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"C:\\projects\\blh\\blh-certification-process","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 723:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/blh_logo.97b6d56.jpg";

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(836),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ab37dd8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(729)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(835),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(834),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(839),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(829),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b171246",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(841),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(731)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(837),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cc473dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(719)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(822),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0aa6d9b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(727)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(831),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(828),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3835618d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(820),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-007f1c33",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(823),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(840),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(722)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(826),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-229d15ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(723)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(827),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3289a174",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(734)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(843),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e5b07000",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(720)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(824),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(726)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(830),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d50d8a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(718)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(821),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01657ee8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(833),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(732)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(838),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e7971bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 820:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (("transform:translate(" + (_vm.value.x) + "px, " + (_vm.value.y) + "px);")),
    attrs: {
      "data-x": _vm.value.x,
      "data-y": _vm.value.y
    }
  }, [_c('md-icon', {
    class: ("md-size-05x status" + (_vm.value.status))
  }, [_vm._v("camera_alt")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 821:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('md-tabs', {
    staticClass: "md-primary",
    attrs: {
      "md-centered": "",
      "md-elevation": "1"
    },
    on: {
      "change": _vm.onAreaChangeDelegate
    }
  }, _vm._l((_vm.certificationProcess.areas), function(area, tabindex) {
    return _c('md-tab', {
      key: tabindex,
      staticStyle: {
        "overflow-wrap": "break-word"
      },
      attrs: {
        "id": ("tab-" + tabindex),
        "md-label": area.name,
        "md-active": (tabindex === _vm.activeIndex)
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(area.name))]), _vm._v(" "), (area.description && area.description.trim().length > 0) ? _c('span', {
      staticClass: "caption"
    }, [_c('b', [_vm._v("Informações adicionais:")]), _vm._v(" " + _vm._s(area.description) + ".")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v("Adicione os equipamentos existentes na área.")])]), _vm._v(" "), _c('md-list', _vm._l((area.structures), function(structure, index) {
      return _c('md-list-item', {
        key: index
      }, [_c('div', {
        staticClass: "md-list-text-container"
      }, [_c('span', [_vm._v(_vm._s(structure.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(structure.description))])]), _vm._v(" "), (area.status !== 2) ? _c('md-button', {
        staticClass: "md-icon-button md-list-action",
        on: {
          "click": function($event) {
            return _vm.onEditStructure(index)
          }
        }
      }, [_c('md-icon', {
        staticClass: "md-primary"
      }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('md-divider', {
        staticClass: "md-inset"
      })], 1)
    }), 1), _vm._v(" "), (area.status === 2) ? _c('p', {
      staticClass: "md-warn md-center"
    }, [_c('md-icon', [_vm._v("warning")]), _vm._v(" "), _c('b', [_vm._v("ATENÇÃO:")]), _vm._v("\n        NÃO É POSSÍVEL ALTERAR OU EDITAR AS INFORMAÇÕES DESTA ÁREA APÓS A\n        SINCRONIZAÇÃO DAS FOTOS.\n      ")], 1) : _c('p', {
      staticClass: "no-equipments"
    }, [_c('md-button', {
      staticClass: "md-raised md-primary",
      on: {
        "click": function($event) {
          return _vm.addStructure()
        }
      }
    }, [_vm._v("ADICIONAR EQUIPAMENTO\n        ")])], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-row": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(tabindex !== 0) ? _c('md-button', {
      staticClass: "md-accent md-dense",
      on: {
        "click": function($event) {
          return _vm.prevArea(tabindex)
        }
      }
    }, [_c('span', [_c('md-icon', {
      staticClass: "md-accent"
    }, [_vm._v("arrow_left")]), _vm._v("ÁREA ANTERIOR")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(_vm.certificationProcess.areas.length > 1 &&
      tabindex !== _vm.certificationProcess.areas.length - 1) ? _c('md-button', {
      staticClass: "md-accent md-dense",
      on: {
        "click": function($event) {
          return _vm.nextArea(tabindex)
        }
      }
    }, [_c('span', [_vm._v("PRÓXIMA ÁREA "), _c('md-icon', {
      staticClass: "md-accent"
    }, [_vm._v("arrow_right")])], 1)]) : _vm._e()], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('addStructureDialog', {
    ref: "add_structure_dialog",
    attrs: {
      "activeProcess": _vm.certificationProcess
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (("-webkit-transform:translate(" + (_vm.value.x) + "px," + (_vm.value.y) + "px);transform:translate(" + (_vm.value.x) + "px, " + (_vm.value.y) + "px);")),
    attrs: {
      "data-x": _vm.value.x,
      "data-y": _vm.value.y
    }
  }, [(_vm.value.type === 'hydraulic') ? _c('md-icon', {
    staticClass: "md-size-05x",
    attrs: {
      "data-key": _vm.number
    }
  }, [_vm._v("opacity")]) : _vm._e(), _vm._v(" "), (_vm.value.type === 'eletric') ? _c('md-icon', {
    staticClass: "md-size-05x",
    attrs: {
      "data-key": _vm.number
    }
  }, [_vm._v("power")]) : _vm._e(), _vm._v(" "), (_vm.value.type === 'equipment') ? _c('md-icon', {
    staticClass: "  md-size-05x",
    attrs: {
      "data-key": _vm.number
    }
  }, [_vm._v("kitchen")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.completed) ? _c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('md-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasError && _vm.areaStarted),
      expression: "!hasError && areaStarted"
    }],
    attrs: {
      "md-progress": _vm.progress
    }
  }), _vm._v(" "), _c('div', [(_vm.hasError) ? _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "md-accent md-raised",
    on: {
      "click": _vm.startProcess
    }
  }, [_vm._v("Tentar Novamente")]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    staticClass: "md-warn md-raised",
    on: {
      "click": _vm.openErrorDialog
    }
  }, [_vm._v("RESOLVER ERRO")]) : _vm._e()], 1), _vm._v(" "), (_vm.hasError) ? _c('sync-error-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError),
      expression: "hasError"
    }],
    ref: "syncErrorDialog",
    attrs: {
      "error": _vm.error,
      "photoErrors": _vm.photoIndexErrors
    },
    on: {
      "restart": _vm.restart
    }
  }) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('md-card', {
    staticClass: "login-card"
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("CERTIFICAÇÃO DAS INSTALAÇÕES E EQUIPAMENTOS DO BLH")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Insira suas credenciais")])]), _vm._v(" "), _c('md-card-content', [_c('md-input-container', [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": "",
      "placeholder": "Digite seu email"
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Email obrigatório")])], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Senha")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": "",
      "type": "password",
      "placeholder": "Digite sua senha"
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Senha obrigatória")])], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Entrar")])], 1)], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": "4000"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.erro))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "md-theme": "light-blue"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("FECHAR")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-viewport",
    attrs: {
      "id": "app"
    }
  }, [_c('md-whiteframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toolbarActive),
      expression: "toolbarActive"
    }],
    staticClass: "main-toolbar",
    attrs: {
      "md-elevation": "3"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRouterPath('home')),
      expression: "!isRouterPath('home')"
    }],
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.blh),
      expression: "blh"
    }]
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', [_vm._v("V2.9.1")]), _vm._v(" "), _c('md-menu-item', {
    on: {
      "selected": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Sair")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('div', {
    staticClass: "blueprint"
  }, [_c('img', {
    ref: "planta",
    attrs: {
      "src": _vm.blueprint,
      "height": _vm.bpHeight,
      "width": _vm.bpWidth
    },
    on: {
      "load": _vm.calculate
    }
  }), _vm._v(" "), _vm._l((_vm.certificationProcess.areas), function(area, key) {
    return _c('div', {
      key: area['.key'],
      class: area.structures || area.status >= 1 ? "notdraggable" : "draggable",
      style: (("-webkit-transform:translate(" + ((_vm.clientWidth / _vm.certificationProcess.bpWidth) * area.x) + "px," + ((_vm.clientHeight / _vm.certificationProcess.bpHeight) * area.y) + "px);transform:translate(" + ((_vm.clientWidth / _vm.certificationProcess.bpWidth) * area.x) + "px," + ((_vm.clientHeight / _vm.certificationProcess.bpHeight)*area.y) + "px);width:" + ((_vm.clientWidth / _vm.certificationProcess.bpWidth) * parseInt(area.w,10)+"px") + "; height:" + ((_vm.clientHeight / _vm.certificationProcess.bpHeight) * parseInt(area.h,10)+"px"))),
      attrs: {
        "data-x": (_vm.clientWidth / _vm.certificationProcess.bpWidth) * area.x,
        "data-y": (_vm.clientHeight / _vm.certificationProcess.bpHeight) * area.y,
        "data-key": key
      }
    }, [_c('draggableArea', {
      attrs: {
        "number": key,
        "value": area
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "resize-edges": "bottom right"
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "resize-edges": "bottom left"
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "resize-edges": "top left"
      }
    }), _vm._v(" "), _c('div', {
      attrs: {
        "resize-edges": "top right"
      }
    }), _vm._v(" "), (area.structures || area.status >= 1) ? _c('md-tooltip', {
      attrs: {
        "md-direction": "top"
      }
    }, [_vm._v("MOVIMENTAÇÃO BLOQUEADA!\n        ")]) : _vm._e(), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "bottom"
      }
    }, [_vm._v("CLIQUE 2X P/ ALTERAR OU EXCLUIR")])], 1)
  })], 2)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-fab-bottom-right",
    on: {
      "click": function($event) {
        return _vm.addArea()
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('add-area-dialog', {
    ref: "add_area_dialog",
    attrs: {
      "activeProcess": _vm.certificationProcess
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('md-whiteframe', {
    staticClass: "camera-toolbar",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.activeItem.name))])]), _vm._v(" "), _c('span', {
    staticClass: "equipment-description"
  }, [_vm._v(_vm._s(_vm.activeItem.description))])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-subheading photo-title"
  }, [_vm._v("Fotografe os focos solicitados abaixo")]), _vm._v(" "), _c('md-stepper', {
    attrs: {
      "md-vertical": "",
      "md-alternate-labels": ""
    },
    on: {
      "completed": _vm.onCompleted
    }
  }, _vm._l((_vm.activeItem.photos), function(photo, key) {
    return _c('md-step', {
      key: photo['.key'],
      attrs: {
        "md-active": key <= 0,
        "photoId": key,
        "md-label": photo.name,
        "md-continue": photo.image !== '' && photo.image !== null && photo.image !== undefined,
        "md-message": photo.description,
        "md-button-continue": _vm.continueButton,
        "md-button-back": "ANTERIOR",
        "md-editable": true
      }
    }, [_c('camera-image-select', {
      ref: "cameraImageSelect",
      refInFor: true,
      attrs: {
        "photoId": key,
        "description": photo.description,
        "imageId": photo.image,
        "imageUrl": photo.url
      },
      on: {
        "add": _vm.addPhoto,
        "select": _vm.previewImage
      }
    })], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 828:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("REGISTRO DE FOTOS")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Nesta etapa você precisa adicionar as fotos dos "), _c('i', [_vm._v("vertices")]), _vm._v(" e "), _c('i', [_vm._v("equipamentos")]), _vm._v(" de cada ÁREA definida.")]), _vm._v(" "), _c('p', {
    staticClass: "md-caption"
  }, [_vm._v("*"), _c('b', [_vm._v("Vértices")]), _vm._v(" são as quatro (4) quinas de cada instalação cadastrada, detalhando o ambiente como um todo."), _c('br')]), _vm._v(" "), (_vm.certificationProcess) ? _c('md-list', _vm._l((_vm.certificationProcess.areas), function(area) {
    return _c('md-list-item', {
      key: area['.key']
    }, [(area.status === 0 || !area.status) ? _c('md-icon', {
      staticClass: "md-warn"
    }, [_vm._v("warning")]) : _c('md-icon', {
      staticClass: "done"
    }, [_vm._v("done_all")]), _vm._v(" "), _c('span', [_vm._v("Área: " + _vm._s(area.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v(_vm._s(area.description))]), _vm._v(" "), _c('md-divider')], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-row": "",
      "md-flex": "",
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.openPhotos()
      }
    }
  }, [_vm._v("FOTOS INSTALAÇÕES/EQUIPAMENTOS")])], 1), _vm._v(" "), (_vm.certificationProcess.status > 4) ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": function($event) {
        return _vm.finishPhotos()
      }
    }
  }, [_vm._v("Próxima Etapa")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "upload_planta_dialog",
    attrs: {
      "md-open-from": "#inicia_processo",
      "md-close-to": "#inicia_processo"
    }
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('label', [_vm._v("Selecione uma imagem")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "accept": "image/*"
    },
    on: {
      "selected": _vm.onBluePrintSelected
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('md-spinner', {
    staticClass: "loading",
    attrs: {
      "md-indeterminate": ""
    }
  }) : _c('div', [_c('md-image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewSrc),
      expression: "previewSrc"
    }],
    ref: "imagePreview",
    attrs: {
      "md-src": _vm.previewSrc
    },
    on: {
      "load": _vm.revokeURL
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("Cancelar\n    ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.confirmSelectedBlueprint
    }
  }, [_vm._v("Prosseguir\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 830:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('md-tabs', {
    staticClass: "md-primary",
    attrs: {
      "md-centered": "",
      "md-elevation": "1",
      "md-dynamic-height": true
    },
    on: {
      "change": _vm.onAreaChangeDelegate
    }
  }, _vm._l((_vm.certificationProcess.areas), function(area, key) {
    return _c('md-tab', {
      key: key,
      attrs: {
        "id": ("tab-" + key),
        "md-label": area.name,
        "md-active": key === _vm.currPhotoArea
      }
    }, [_c('div', {
      attrs: {
        "md-column": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(area.name) + "\n          ")]), _vm._v(" "), (area.description && area.description.trim().length > 0) ? _c('span', {
      staticClass: "caption"
    }, [_c('b', [_vm._v("Informações adicionais:")]), _vm._v(" " + _vm._s(area.description) + ".")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v("Adicione as fotos de acordo com os items abaixo.")])]), _vm._v(" "), _c('md-list', [_c('md-subheader', {
      staticClass: "md-primary"
    }, [_vm._v("\n              VÉRTICES \n              "), _c('span', {
      staticClass: "md-caption"
    }, [_vm._v(" **"), _c('b', [_vm._v("Vértices")]), _vm._v(" são as quatro (4) quinas de cada instalação cadastrada, detalhando o ambiente como um todo."), _c('br')])]), _vm._v(" "), _vm._l((area.vertices), function(vertice, index) {
      return _c('md-list-item', {
        key: ("vertice" + index),
        on: {
          "click": function($event) {
            return _vm.addPhotos(index, vertice.type)
          }
        }
      }, [_c('div', {
        staticClass: "md-list-text-container"
      }, [_c('span', [_vm._v(_vm._s(vertice.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(vertice.description))])]), _vm._v(" "), _c('md-button', {
        staticClass: "md-icon-button md-list-action"
      }, [(vertice.status === 1) ? _c('md-icon', {
        staticClass: "done"
      }, [_vm._v("done")]) : _c('md-icon', [_vm._v("add_a_photo")])], 1), _vm._v(" "), _c('md-divider', {
        staticClass: "md-inset"
      })], 1)
    }), _vm._v(" "), (area.structures) ? _c('md-subheader', {
      staticClass: "md-primary"
    }, [_vm._v("EQUIPAMENTOS")]) : _vm._e(), _vm._v(" "), _vm._l((area.structures), function(structure, index) {
      return _c('md-list-item', {
        key: ("structure" + index),
        on: {
          "click": function($event) {
            return _vm.addPhotos(index, structure.type)
          }
        }
      }, [_c('div', {
        staticClass: "md-list-text-container"
      }, [_c('span', [_vm._v(_vm._s(structure.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(structure.description.slice(0, 35)))])]), _vm._v(" "), _c('md-button', {
        staticClass: "md-icon-button md-list-action"
      }, [(structure.status === 1) ? _c('md-icon', {
        staticClass: "done"
      }, [_vm._v("done")]) : _c('md-icon', [_vm._v("add_a_photo")])], 1), _vm._v(" "), _c('md-divider', {
        staticClass: "md-inset"
      })], 1)
    })], 2), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(_vm.isAreaFinished) ? _c('router-link', {
      staticClass: "md-raised md-primary",
      attrs: {
        "tag": "md-button",
        "to": "/syncArea"
      }
    }, [_vm._v("ENVIAR FOTOS E LIBERAR MEMÓRIA")]) : _vm._e(), _vm._v(" "), (_vm.isAreaFinished) ? _c('span', {
      staticClass: "caption"
    }, [_vm._v("*Este passo "), _c('b', [_vm._v("não é obrigatório")]), _vm._v(", porém recomendado. Após a sincronização não será possível alterar as fotos desta área.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-row": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(key !== 0) ? _c('md-button', {
      staticClass: "md-accent md-dense",
      on: {
        "click": function($event) {
          return _vm.prevArea(key)
        }
      }
    }, [_c('span', [_c('md-icon', {
      staticClass: "md-accent"
    }, [_vm._v("arrow_left")]), _vm._v("ÁREA ANTERIOR")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(_vm.certificationProcess.areas.length > 1 &&
      key !== _vm.certificationProcess.areas.length - 1) ? _c('md-button', {
      staticClass: "md-accent md-dense",
      on: {
        "click": function($event) {
          return _vm.nextArea(key)
        }
      }
    }, [_c('span', [_vm._v("PRÓXIMA ÁREA "), _c('md-icon', {
      staticClass: "md-accent"
    }, [_vm._v("arrow_right")])], 1)]) : _vm._e()], 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-boards', {
    staticClass: "md-primary hello-board",
    attrs: {
      "md-controls": true
    }
  }, [_c('md-board', {
    staticClass: "hello-board slide1",
    attrs: {
      "id": "slide1"
    }
  }, [_c('md-layout', {
    staticClass: "title",
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-headline"
  }, [_vm._v("CERTIFICAÇÃO DAS INSTALAÇÕES E EQUIPAMENTOS DO BLH")]), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("BEM VINDO")])]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(796)
    }
  })], 1), _vm._v(" "), _c('md-board', {
    staticClass: "hello-board slide2"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("\n        Para acessar a certificação, entre com os dados de usuario e senha.\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("\n        Estes dados são fornecido após o processo de credenciamento.\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("\n        Qualquer dúvida entre em contato através do site "), _c('a', {
    attrs: {
      "href": "https://rblh.fiocruz.br"
    }
  }, [_vm._v("Rede Brasileira de Bancos de Leite Humano")])]), _vm._v(" "), _c('md-button', {
    staticClass: "login md-raised md-accent",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Acessar o Processo de Certificação")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.certificationProcess.status <= 6) ? _c('md-layout', {
    key: "syncInformations"
  }, [(_vm.queueStatus === 'creating') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("CARREGANDO INFORMAÇÕES")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Esta é a ultima etapa do processo de certificação do banco de leite\n        humano, nesta etapa você precisa manter o WI-FI do seu celular ligado\n        até que o envio esteja concluído.")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.queueLog))]), _vm._v(" "), _c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : (_vm.queueStatus === 'waiting') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("ENVIO DAS INFORMAÇÕES")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Esta é a ultima etapa do processo de certificação do banco de leite\n        humano, nesta etapa você precisa manter o WI-FI do seu celular ligado\n        até que o envio esteja concluído.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    attrs: {
      "disabled": !_vm.networkStatus
    },
    on: {
      "click": _vm.startQueue
    }
  }, [_vm._v("Iniciar a Sincronização\n      ")])], 1) : (_vm.queueStatus === 'running') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("ENVIANDO FOTOS PARA NUVEM")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Durante esse processo mantenha o aplicativo aberto e WI-FI\n        ligado.")]), _vm._v(" "), _c('md-progress', {
    staticClass: "md-warn",
    attrs: {
      "md-size": 150,
      "md-progress": _vm.progress
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.queueLog) + " "), _c('br'), _vm._v("\n        Total: " + _vm._s(_vm.queue.size) + " Pendente: " + _vm._s(_vm.queue.pending)), _c('br'), _vm._v("\n        Area Atual: " + _vm._s(_vm.currentArea)), _c('br'), _vm._v("\n        Item Atual: " + _vm._s(_vm.currentItem)), _c('br'), _vm._v("\n        Foto Atual: " + _vm._s(_vm.currentPhoto) + "\n      ")])], 1) : (_vm.queueStatus === 'error') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("OCORREU UM ERRO AO ENVIAR OS DADOS PARA A NUVEM!")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Verifique os motivos abaixo antes de tentar novamente.")]), _vm._v(" "), _c('md-list', {
    staticClass: "custom-list md-triple-line"
  }, [_vm._l((_vm.faultyPhotos), function(object, key) {
    return _c('md-list-item', [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(object.item.name))]), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v("FOTO: " + _vm._s(object.photo.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(object.error))])]), _vm._v(" "), _c('md-button', {
      staticClass: "md-icon-button md-list-action",
      on: {
        "click": function($event) {
          return _vm.captureNewPhoto(object)
        }
      }
    }, [_c('md-icon', {
      staticClass: "md-primary"
    }, [_vm._v("upload_file")])], 1), _vm._v(" "), _c('md-divider', {
      staticClass: "md-inset"
    })], 1)
  }), _vm._v(" "), (_vm.blueprintError != '') ? _c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("PLANTA BAIXA DO BLH")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.blueprintError))])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        return _vm.captureNewBlueprint()
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("upload_file")])], 1), _vm._v(" "), _c('md-divider', {
    staticClass: "md-inset"
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    attrs: {
      "disabled": !_vm.networkStatus
    },
    on: {
      "click": _vm.restartQueue
    }
  }, [_vm._v("Tentar a Sincronização Novamente\n      ")])], 1) : _vm._e()], 1) : _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Parabéns!\n      "), _c('b', [_vm._v(_vm._s(_vm.blh.name))])]), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("CERTIFICAÇÃO " + _vm._s(_vm.blh.currentYear) + " ENVIADA COM SUCESSO!")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Seu processo está em fase de análise, qualquer dúvida entre em contato\n      conosco")])]), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": Infinity
    }
  }, [_c('span', [_vm._v("Sem conexão com a internet! Conecte a uma rede wi-fi e tente novamente.")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [(_vm.certificationProcess.areas[this.activeArea].status <= 1) ? _c('md-layout', {
    key: "syncInformations"
  }, [(_vm.queueStatus === 'creating') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("CARREGANDO INFORMAÇÕES")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Nesta etapa você precisa manter o WI-FI do seu celular ligado\n        até que o envio esteja concluído.")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v(_vm._s(_vm.queueLog))]), _vm._v(" "), _c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : (_vm.queueStatus === 'waiting') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("ENVIO DAS FOTOS PARA NUVEM")]), _vm._v(" "), _c('span', [_vm._v("Esta é uma etapa do processo que visa enviar as fotos para nuvem e liberar espaço na memória do aparelho. ")]), _vm._v(" "), _c('p', [_vm._v("Seu processo "), _c('b', [_vm._v("NÃO SERÁ CONCLUÍDO")]), _vm._v(" nesse momento, após finalizar a sincronização você poderá continuar\n        normalmente.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    attrs: {
      "disabled": !_vm.networkStatus
    },
    on: {
      "click": _vm.startQueue
    }
  }, [_vm._v("Iniciar a Sincronização\n      ")])], 1) : (_vm.queueStatus === 'running') ? _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("ENVIANDO FOTOS PARA NUVEM")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Durante esse processo mantenha o aplicativo aberto e WI-FI\n        ligado.")]), _vm._v(" "), _c('md-progress', {
    staticClass: "md-warn",
    attrs: {
      "md-size": 150,
      "md-progress": _vm.progress
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        " + _vm._s(_vm.queueLog) + "\n        Total: " + _vm._s(_vm.queue.size) + " Pendente: " + _vm._s(_vm.queue.pending)), _c('br'), _vm._v("\n        Area Atual: " + _vm._s(_vm.currentArea)), _c('br'), _vm._v("\n        Item Atual: " + _vm._s(_vm.currentItem)), _c('br'), _vm._v("\n        Foto Atual: " + _vm._s(_vm.currentPhoto) + "\n      ")])], 1) : _vm._e()], 1) : _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("SINCRONIZAÇÃO DA ÁREA "), _c('b', [_vm._v(_vm._s(_vm.currentArea))]), _vm._v(" EFETUADA COM SUCESSO!\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("As fotos foram liberadas da memória, continue com seu processo de\n      certificação.")])]), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": Infinity
    }
  }, [_c('span', [_vm._v("Sem conexão com a internet! Conecte a uma rede wi-fi e tente\n      novamente.")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("INSTALAÇÕES")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Siga o passo a passo abaixo com atenção. ")]), _vm._v(" "), _c('md-stepper', {
    attrs: {
      "md-vertical": "",
      "md-elevation": "0"
    },
    on: {
      "completed": function($event) {
        return _vm.finishArea()
      }
    }
  }, [_c('md-step', {
    attrs: {
      "md-continue": _vm.certificationProcess.status > 0,
      "md-active": _vm.certificationProcess.status <= 0,
      "md-label": "Carregamento da Planta do BLH",
      "md-button-back": "Voltar",
      "md-button-continue": "Próximo: INSTALAÇÕES"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('p', [_vm._v("Selecione a planta baixa, fundo branco e linhas pretas.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.openBlueprintDialog()
      }
    }
  }, [_vm._v("DEFINIR PLANTA BLH")])], 1)], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "md-continue": _vm.certificationProcess.status > 1,
      "md-active": _vm.certificationProcess.status == 1,
      "md-label": "Definição das Instalações",
      "md-button-back": "Voltar",
      "md-button-continue": "Próximo: EQUIPAMENTOS"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('p', [_vm._v("Descreva as instalações do banco de leite humano")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.openAreas()
      }
    }
  }, [_vm._v("INSTALAÇÕES DO BLH")])], 1)], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "md-continue": _vm.certificationProcess.status > 2,
      "md-active": _vm.certificationProcess.status >= 2,
      "md-label": "Listagem de Equipamentos",
      "md-button-back": "Voltar",
      "md-button-continue": "Próximo: Fotos"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.openStructure()
      }
    }
  }, [_vm._v("EQUIPAMENTOS DO BLH")])], 1)], 1)], 1), _vm._v(" "), _c('blueprint-dialog', {
    ref: "startdialog",
    attrs: {
      "title": "Planta do BLH",
      "imageId": _vm.certificationProcess.blueprint,
      "blueprintUrl": _vm.certificationProcess.blueprintUrl
    },
    on: {
      "select": _vm.blueprintSelected
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar_sync",
    attrs: {
      "md-position": 'bottom center',
      "md-duration": Infinity
    }
  }, [(_vm.isSyncingArea && !_vm.syncSuccessfull) ? _c('span', [_vm._v("Salvando...")]) : _vm._e(), _vm._v(" "), (_vm.syncSuccessfull) ? _c('span', [(_vm.hasError !== '') ? _c('span', [_vm._v("\n        " + _vm._s(_vm.hasError) + "\n      ")]) : _c('span', [_vm._v("\n        ENVIADO COM SUCESSO!\n      ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "md-theme": "light-blue"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.snackbar_sync.close()
      }
    }
  }, [_vm._v("Fechar")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "equipamentoDialog"
  }, [_c('md-dialog', {
    ref: "eq_dialog",
    attrs: {
      "md-open-from": "#addEquipamento",
      "md-close-to": "#addEquipamento"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "display": "contents"
    }
  }, [_c('md-dialog-content', [_c('md-layout', {
    attrs: {
      "md-align": "center",
      "md-column": "",
      "md-gutter": ""
    }
  }, [_c('span', {
    staticClass: "md-headline"
  }, [_vm._v("SALVANDO")]), _vm._v(" "), _c('md-spinner', {
    attrs: {
      "md-size": 50,
      "md-stroke": 1,
      "md-indeterminate": ""
    }
  })], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "display": "contents"
    }
  }, [_c('md-dialog-title', [_vm._v("Equipamento")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('label', [_vm._v("Tipo do item")]), _vm._v(" "), _c('md-select', {
    model: {
      value: (_vm.structure),
      callback: function($$v) {
        _vm.structure = $$v
      },
      expression: "structure"
    }
  }, _vm._l((_vm.equipmentList), function(eq, index) {
    return _c('md-option', {
      key: eq.name,
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(eq.name))])
  }), 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Informações adicionais")]), _vm._v(" "), _c('md-textarea', {
    attrs: {
      "maxlength": "120"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Marca")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.brand),
      callback: function($$v) {
        _vm.brand = $$v
      },
      expression: "brand"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Modelo")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "100"
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Patrimônio")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "maxlength": "120"
    },
    model: {
      value: (_vm.patrimony),
      callback: function($$v) {
        _vm.patrimony = $$v
      },
      expression: "patrimony"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentItemKey != null),
      expression: "currentItemKey != null"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.removeItem()
      }
    }
  }, [_vm._v("Excluir")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentItemKey != null),
      expression: "currentItemKey != null"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.saveItem()
      }
    }
  }, [_vm._v("Alterar")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentItemKey == null),
      expression: "currentItemKey == null"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("Adicionar")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 836:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "areaDialog"
  }, [_c('md-dialog', {
    ref: "add_area_dialog",
    attrs: {
      "md-open-from": "#addArea",
      "md-close-to": "#addArea"
    }
  }, [_c('md-dialog-title', [_vm._v("Informações da Área")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('label', [_vm._v("Nome da Area")]), _vm._v(" "), _c('md-select', {
    model: {
      value: (_vm.area.name),
      callback: function($$v) {
        _vm.$set(_vm.area, "name", $$v)
      },
      expression: "area.name"
    }
  }, _vm._l((_vm.areaList), function(area, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": area.name
      }
    }, [_vm._v(_vm._s(area.name))])
  }), 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Informações adicionais")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.area.description),
      callback: function($$v) {
        _vm.$set(_vm.area, "description", $$v)
      },
      expression: "area.description"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "conformidade"
    }
  }, [_vm._v("Acordo com exigência legal")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "conformidade",
      "id": "conformidade",
      "required": "",
      "multiple": ""
    },
    model: {
      value: (_vm.area.conformidade),
      callback: function($$v) {
        _vm.$set(_vm.area, "conformidade", $$v)
      },
      expression: "area.conformidade"
    }
  }, _vm._l((_vm.itensRDC50), function(option, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": option.id
      }
    }, [_vm._v("\n            " + _vm._s(option.name) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Tipo de revestimento do piso")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.area.tipoPiso),
      callback: function($$v) {
        _vm.$set(_vm.area, "tipoPiso", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "area.tipoPiso"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Tipo de revestimento do teto")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.area.tipoTeto),
      callback: function($$v) {
        _vm.$set(_vm.area, "tipoTeto", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "area.tipoTeto"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Tipo de revestimento da parede")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.area.tipoParede),
      callback: function($$v) {
        _vm.$set(_vm.area, "tipoParede", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "area.tipoParede"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.areakey),
      expression: "this.areakey"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.removeArea()
      }
    }
  }, [_vm._v("Excluir")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.areakey),
      expression: "this.areakey"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.saveArea()
      }
    }
  }, [_vm._v("Alterar")]), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.areakey),
      expression: "!this.areakey"
    }],
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.addArea()
      }
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 837:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "data-key": _vm.number,
      "viewBox": "0 -200 1000 300",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('rect', {
    attrs: {
      "data-key": _vm.number,
      "x": "0",
      "y": "0",
      "widt": "200",
      "height": "200",
      "fill": "white"
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "area-title",
    attrs: {
      "data-key": _vm.number,
      "fill": "#fff",
      "font-size": "180",
      "x": "50%",
      "y": "-30%",
      "text-anchor": "middle"
    }
  }, [_vm._v("\n    A" + _vm._s(_vm.number + 1) + "\n  ")]), _vm._v(" "), _c('text', {
    staticClass: "area-title",
    attrs: {
      "data-key": _vm.number,
      "fill": "#fff",
      "font-size": "110",
      "y": "10%",
      "x": "50%",
      "text-anchor": "middle"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.areaName)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.certificationProcess.status <= 6) ? _c('md-layout', {
    key: "syncInformations",
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("SINCRONIZAR INFORMAÇÕES TEMPORARIAMENTE")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Este processo visa sincronizar as informações coletadas até o momento e liberar espaço para coletar mais.")]), _vm._v(" "), (_vm.syncStarted) ? _c('md-list', _vm._l((_vm.certificationProcess.areas), function(area) {
    return _c('area-sync-list', {
      key: area.id,
      attrs: {
        "area": area
      },
      on: {
        "areaSynced": _vm.handleAreaSync
      }
    })
  }), 1) : _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": _vm.startSync
    }
  }, [_vm._v("Iniciar a Sincronização")])], 1) : _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("SUCESSO!\n      "), _c('b', [_vm._v(_vm._s(_vm.blh.name))])]), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("DADOS TEMPORARIOS SINCRONIZADO COM SUCESSO!")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Agora você pode continuar com a captura de informações")])]), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "bottom center",
      "md-duration": Infinity
    }
  }, [_c('span', [_vm._v("Sem conexão com a internet, não é possível sincronizar.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    on: {
      "click": function($event) {
        return _vm.createSyncWorkers()
      }
    }
  }, [_vm._v("Reiniciar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.completed) ? _c('md-list-item', [_c('md-icon', [_vm._v("cloud_upload")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.area.name))]), _vm._v(" "), (!_vm.hasStarted) ? _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": _vm.startArea
    }
  }, [_vm._v("INICIAR UPLOAD")]) : _vm._e(), _vm._v(" "), _c('md-list-expand', [_c('md-list', _vm._l((_vm.area.structures), function(item, key) {
    return _c('structure-sync-item', {
      key: item['.key'],
      attrs: {
        "areaStarted": _vm.hasStarted,
        "id": key,
        "name": item.name,
        "photos": item.photos,
        "status": item.status,
        "areaId": _vm.area.id,
        "itemId": item.id,
        "type": item.type
      },
      on: {
        "structureSynced": _vm.structureSyncHandler
      }
    })
  }), 1), _vm._v(" "), _c('md-list', _vm._l((_vm.area.vertices), function(item, key) {
    return _c('structure-sync-item', {
      key: item['.key'],
      attrs: {
        "id": key,
        "areaStarted": _vm.hasStarted,
        "name": item.name,
        "photos": item.photos,
        "status": item.status,
        "areaId": _vm.area.id,
        "itemId": item.id.toString(),
        "type": item.type
      },
      on: {
        "structureSynced": _vm.verticeSyncHandler
      }
    })
  }), 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "synErrorDialog"
  }, [_c('md-dialog-title', [_vm._v("Resolução de erro")]), _vm._v(" "), _c('md-dialog-content', [_c('div', [_c('span', [_c('b', [_vm._v("Fonte do problema:")]), _vm._v(" " + _vm._s(_vm.error))])]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Itens com problema")])]), _vm._v(" "), _c('md-list', _vm._l((_vm.photoErrors), function(item, key) {
    return _c('md-list-item', {
      key: item['.key']
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(item.name) + " - " + _vm._s(item.photo.name))]), _vm._v(" "), _c('camera-image-select', {
      ref: "cameraImageSelect",
      refInFor: true,
      attrs: {
        "photoId": key,
        "description": item.photo.description,
        "imageId": item.photo.image
      }
    })], 1)])
  }), 1), _vm._v(" "), _c('div', [_c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": _vm.startProcess
    }
  }, [_vm._v("ENVIAR DADOS")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.meetRequisites) ? _c('div', [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Verifique os motivos abaixo e tente novamente.")]), _vm._v(" "), _c('md-list', [_vm._l((_vm.messages), function(msg, index) {
    return _c('md-list-item', {
      key: index
    }, [_c('md-icon', [_vm._v("warning")]), _c('span', [_vm._v(_vm._s(msg))])], 1)
  }), _vm._v(" "), (_vm.notEmptyObject(_vm.navigator)) ? _c('md-list-item', [_c('md-icon', [_vm._v("web")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.navigator))])], 1) : _vm._e(), _vm._v(" "), (_vm.notEmptyObject(_vm.ram)) ? _c('md-list-item', [_c('md-icon', [_vm._v("memory")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ram))])], 1) : _vm._e(), _vm._v(" "), (_vm.notEmptyObject(_vm.storage)) ? _c('md-list-item', [_c('md-icon', [_vm._v("storage")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.storage))])], 1) : _vm._e()], 2), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Você pode continuar, porém as funcionalidades serão reduzidas e você precisará de internet para capturar as fotos.")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.continueWithProcess
    }
  }, [_vm._v("Continuar com o Processo")])], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "md-title"
  }, [_c('b', [_vm._v("Atenção!")]), _vm._v(" seu aparelho não atende as especificações de utilização do aplicativo.")])
}]}

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera-image-preview"
  }, [_c('label', {
    staticClass: "file-select"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imgSrc),
      expression: "!imgSrc"
    }],
    staticClass: "select-button"
  }, [_vm._v("\n      ADICIONAR FOTO\n    ")]), _vm._v(" "), (_vm.isLoading && _vm.imgSrc) ? _c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgSrc),
      expression: "imgSrc"
    }],
    attrs: {
      "src": _vm.imgSrc
    },
    on: {
      "load": _vm.revokeURL
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    domProps: {
      "value": _vm.inputfile
    },
    on: {
      "change": _vm.handleFileChange
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(!_vm.hasLoaded) ? _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  }, [_c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-body-1"
  }, [_vm._v("Carregando dados da aplicação...")])], 1) : _vm._e(), _vm._v(" "), _c('check-requisites', {
    on: {
      "onRequisitesCheck": _vm.onRequisitesCheck
    }
  }), _vm._v(" "), (_vm.meetRequisites) ? _c('div', [(!_vm.blh) ? _c('md-layout', {
    staticClass: "start-process",
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Selecione o BLH antes de prosseguir")]), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "select-userBlhs"
    }
  }, [_vm._v("Banco de Leite Humano")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "select-userBlhs",
      "id": "select-userBlhs"
    },
    model: {
      value: (_vm.selectedBLH),
      callback: function($$v) {
        _vm.selectedBLH = $$v
      },
      expression: "selectedBLH"
    }
  }, _vm._l((_vm.userBlhs), function(blh, index) {
    return _c('md-option', {
      key: blh.id,
      attrs: {
        "value": index
      }
    }, [_vm._v(_vm._s(blh.name))])
  }), 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.setActiveBLH
    }
  }, [_vm._v("PROSSEGUIR")])], 1) : (!_vm.certificationProcess && _vm.blh) ? _c('md-layout', {
    staticClass: "start-process",
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Olá "), _c('b', [_vm._v(_vm._s(_vm.blh.name))]), _vm._v(", seja bem vindo ao")]), _vm._v(" "), _c('span', {
    staticClass: "md-title"
  }, [_vm._v("PROCESSO DE CERTIFICAÇÃO " + _vm._s(_vm.blh.currentYear))]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Antes de iniciar o processo, veja atentamente as instruções abaixo")]), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("Atenção: lembre-se de reunir a planta e as informaçoes necessárias do " + _vm._s(_vm.blh.name))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        return _vm.startCertificationProcess()
      }
    }
  }, [_vm._v("INICIAR PROCESSO DE CERTIFICAÇÃO")])], 1) : _c('md-layout', [_c('md-tabs', {
    ref: "tabs",
    staticClass: "md-transparent",
    attrs: {
      "md-centered": "",
      "md-fixed": ""
    },
    on: {
      "change": _vm.changeHandler
    }
  }, [_c('md-tab', {
    ref: "tabAreas",
    attrs: {
      "md-label": "INSTALAÇÕES",
      "md-icon": "layers",
      "md-active": _vm.isAreaActive,
      "md-disabled": _vm.certificationProcess.status >= 6
    }
  }, [_c('area-definitions')], 1), _vm._v(" "), _c('md-tab', {
    ref: "tabFotos",
    attrs: {
      "md-label": "Fotos",
      "md-icon": "camera_alt",
      "md-disabled": _vm.certificationProcess.status < 4 || _vm.certificationProcess.status >= 6,
      "md-active": _vm.isPhotoActive
    }
  }, [(_vm.isPhotoActive) ? _c('photos-list') : _vm._e()], 1), _vm._v(" "), _c('md-tab', {
    ref: "tabReview",
    attrs: {
      "md-label": "Revisão",
      "md-icon": "visibility",
      "md-disabled": _vm.certificationProcess.status < 5 || _vm.certificationProcess.status >= 6,
      "md-active": _vm.isReviewActive
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', [_c('p', [_vm._v("Muito bem! Você preencheu todos as informações, agora é o momento de revisar, fique à vontade, verifique todas as informações e assim que estiver tudo pronto, clique no botão abaixo.")]), _vm._v(" "), _c('p', [_vm._v("IMPORTANTE! Após esta etapa não será possível alterar os dados da certificação")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": function($event) {
        return _vm.startSync()
      }
    }
  }, [_vm._v("SUBMETER DADOS DE CERTIFICAÇÃO")])], 1)], 1), _vm._v(" "), _c('md-tab', {
    ref: "tabSyncronization",
    attrs: {
      "md-label": "Submeter",
      "md-icon": "backup",
      "md-disabled": _vm.certificationProcess.status < 6,
      "md-active": _vm.isSubmitActive
    }
  }, [(_vm.isSubmitActive) ? _c('sync-queue') : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[392]);


// WEBPACK FOOTER //
// static/js/app.2937e574143c6b4c4942.js